import { makeAutoObservable, runInAction } from 'mobx';
import { toast } from 'react-toastify';
import agent from '../api/agent';
import {
  Activity,
  ActivityFormValues,
  FilterAssetsDetailsI,
} from '../models/activity';
import { FileUploadInterface } from '../models/Profile';
import { store } from './store';
import { WorkLevelItem } from '../models/workLevel';
import { HistoryViewItemLevel, historyPayloadType } from '../models/history';
import { EmailNew } from '../models/EmailNew';
import fileDownload from 'js-file-download';
import { DeliveryRequest } from '../models/deliveryRequest';
import { HFCServiceInfo, HFCServiceInfoInitialdata, HFCShipperInfo, HFCShipperInfoInitialdata } from '../models/ReceivingDelivery';
import dashboardStore from './dashboardStore';
import { sortNameReset } from './CRMStore/types';
import { addPreviousTasksAndSubtasks, PostFilteredItemDetailsTypes } from '../models/metaDataConfig';

export const filterDetails = {
  assetCleanedThisMonth: 0,
  currentMonthAssetCanMovement: 0,
  deliveryAssetApproved: 0,
  deliveryAssetPickerAssigned: 0,
  deliveryOrdercreated: 0,
  newAssetTitlesAddedInThisMonth: 0,
  orderRegistered: 0,
  pendingReturnsFromBorrower: 0,
  readyfordelivery: 0,
  receivingOrderCreated: 0,
  tagged: 0,
};

// interface FormData {
//   id: string;
//   itemGroupId:string;
//   title: string;
//   asset_Id: string;
//   print: string;
//   vault: string;
//   elementId: string;
//   shipping_Date: string;
//   return_Date: string;
//   shipping_Location: string;
//   address: string;
//   account: string;
//   requested_By: string;
//   requester_Email: string;
//   assets_Associated_with_Title_and_Asset_ID: string;
//   notes: string;
// }

export default class ActivityStore {
  activityRegistry = new Map<string, Activity>();

  activityRegistryAll = new Map<string, Activity>();
  activityRegistryBarcode = new Map<string, Activity>();
  activityRegistryQrcode = new Map<string, Activity>();
  activityRegistryrfid = new Map<string, Activity>();
  inwardsRegistry = new Map<string, Activity>();
  outwardsRegistry = new Map<string, Activity>();
  deliveryRegistry = new Map<string, Activity>();
  selectedActivity: Activity | undefined = undefined;
  selectedShipper: HFCShipperInfo | undefined= HFCShipperInfoInitialdata;
  selectedReceiver: HFCShipperInfo | undefined= HFCShipperInfoInitialdata;
  selectedService: HFCServiceInfo | undefined =HFCServiceInfoInitialdata;
  selectedReturn: HFCServiceInfo | undefined =HFCServiceInfoInitialdata;
  selectedServiceAssign:HFCServiceInfo | undefined =HFCServiceInfoInitialdata;
  activeTask: Activity | undefined = undefined;
  selectedDelivery: Activity | undefined = undefined;
  updateSchedule: boolean = false;
  scheduleEditOpen: boolean = false;
  ServiceCount:any=[]
  data: any;
  loading = false;
  loadingInitial = false;
  loadingInitialSections = false;
  loadSectionsData = '';
  currentPage: number = 1;
  isThisFilterCategory: boolean = false;
  isFilterApiCalled = false;
  groupIdCountsDetails: {
    id: string;
    title: string;
  }[] = [];
  Filter: string = '';
  FilterCategory: string = '';
  filterItem = '';
  FilterById = '';
  filterMethod: string = '';
  filteredAssetsCount: number = 1;
  groupActivitiesAllData: any;
  filterAssetsDetails: FilterAssetsDetailsI = filterDetails;
  downloadFileStarted: any = '';
  isActivity = false;
  isActivity2 = false;
  orderRegisterTrigger = false;
  metaDataVal: any | undefined = undefined;
  isGrplength = true;
  errorMessageKalaingar = '';
  errorMessageKalaingarr: any = '';
  eroorr = false;
  historyAttachmentFiles: FileUploadInterface[] = [];
  fileDataVoice: FileUploadInterface[] = [];
  trackgatemessage: string = '';
  historyData: HistoryViewItemLevel[] = [];
  historyPageNumber: number = 0;
  viewTemplatePageNumber: number = 0;
  viewTemplateOrderDetails: any = [];
  isViewHistoryLoading: boolean = false;
  isViewTemplateLoading: boolean = false;
  AssetsOrderInfomation: any[] = [];
  movementtracker: any[] = [];
  peopleSelected: any = {};
  peopleData: boolean = false;
  timeDuration: number[] = [];
  usertracker: any[] = [];
  mepzActivities:any[]=[];
  loadingActiviyAll: boolean = false;
  historyCount: number = 1;
  orderHistoryCount: any;
  viewTemplateCount: number = 1;
  loadTagLoading = false;
  loadCRLoading = false;
  loadCountAssetTable: boolean = false;
  loadProductionTable: boolean = false;
  createOrderDepartmentName: string = '';
  imageSrc: any[] = [];
  sectionOrderDepartmentName: string = '';
  sectionOrderDepartmentId: string = '';
  ActivityQuickscanData: any[] = [];
  // objectSelected:any={};
  // objectData:boolean=false;
  allocateUserTableData: string[] = [];
  typeProduction: any[] = [];
  taskTypeProduction: any[] = [];
  orderTabCurrentpage: number = 1;
  ActivityQuickscanIs: boolean = false;
  prodTask: string = "";
  prodSubTasks: string = "";

  //====== movement tracker view =====
  setOpenmovementview: boolean = false;

  // ------ Inventory Reports ------ //
  inventoryReports = {
    newAssetAdded: {
      isLoading: false,
      pageNumber: 1,
      count: 0,
      data: [],
    },
    currentMonthAssetCANMovement: {
      isLoading: false,
      pageNumber: 1,
      count: 0,
      data: [],
    },
    pendingReturnsFromBorrowers: {
      isLoading: false,
      pageNumber: 1,
      count: 0,
      data: [],
    },
    assetsScheduledForCleaning: {
      isLoading: false,
      pageNumber: 1,
      count: 0,
      data: [],
    },
    assetsCleaned: {
      isLoading: false,
      pageNumber: 1,
      count: 0,
      data: [],
    },
    digitalizationPriority: {
      isLoading: false,
      pageNumber: 1,
      count: 0,
      data: [],
    },
  };

  // ----- order reports ---- //
  OrdersReports = {
    received: {
      pageNumber: 1,
      isLoading: false,
      data: [],
      count: 0,
    },
    waitingforApproval: {
      pageNumber: 1,
      isLoading: false,
      data: [],
      count: 0,
    },
    approved: {
      pageNumber: 1,
      isLoading: false,
      data: [],
      count: 0,
    },
    inProgress: {
      pageNumber: 1,
      isLoading: false,
      data: [],
      count: 0,
    },
    ready: {
      pageNumber: 1,
      isLoading: false,
      data: [],
      count: 0,
    },
    delivered: {
      pageNumber: 1,
      isLoading: false,
      data: [],
      count: 0,
    },
    returned: {
      pageNumber: 1,
      isLoading: false,
      data: [],
      count: 0,
    },
  };

  // --------------- inward -------------- //
  inward = {
    verify: {
      pageNumber: 1,
      isLoading: false,
      data: [],
      count: 0,
    },
    approve: {
      pageNumber: 1,
      isLoading: false,
      data: [],
      count: 0,
    },
    moveToVault: {
      pageNumber: 1,
      isLoading: false,
      data: [],
      count: 0,
    },
    PickerAssign: {
      pageNumber: 1,
      isLoading: false,
      data: [],
      count: 0,
    },
  };

  outward = {
    tagOrder: {
      pageNumber: 1,
      isLoading: false,
      data: [],
      count: 0,
    },
    unvault: {
      pageNumber: 1,
      isLoading: false,
      data: [],
      count: 0,
    },
    verifyOutward: {
      pageNumber: 1,
      isLoading: false,
      data: [],
      count: 0,
    },
    approveOutward: {
      pageNumber: 1,
      isLoading: false,
      data: [],
      count: 0,
    },
    assignPickerOutward: {
      pageNumber: 1,
      isLoading: false,
      data: [],
      count: 0,
    },
    move: {
      pageNumber: 1,
      isLoading: false,
      data: [],
      count: 0,
    },
    package: {
      pageNumber: 1,
      isLoading: false,
      data: [],
      count: 0,
    },
    billing: {
      pageNumber: 1,
      isLoading: false,
      data: [],
      count: 0,
      billType: '',
      amount: '',
    },
    assignPickerDefault: {
      pickerName: '',
      pickerPhoneNumber: '',
    },
  };
  orderTabload: boolean = false;
  HfcSelectedRow:number = 5;

  setFilterCategoryString = (d: string, filterCount: number) => {
    this.FilterCategory = d;
    this.OrderModelTab(d, this.orderTabCurrentpage);
    if (filterCount > 0) {
      this.isGrplength = true;
    } else {
      this.isGrplength = false;
    }
  };
  setFilterId = (d: string) => {
    this.Filter = d;
  };

  setTask(name: string) {
    this.prodTask = name;
  }

  addSubTask(name: string) {
    this.prodSubTasks = name;
  }

  clearAll() {
    this.prodTask = "";
    this.prodSubTasks = "";
  }

  constructor() {
    makeAutoObservable(this);
  }

  get activitiesByDate() {
    return Array.from(this.activityRegistry.values());
  }
  get activitiesAll() {
    return Array.from(this.activityRegistryAll.values()).sort(
      (a, b) =>
        new Date(b.itemCreatedAt).getTime() -
        new Date(a.itemCreatedAt).getTime(),
    );
  }

  get inwardsByDate() {
    return Array.from(this.inwardsRegistry.values())
      .filter((x) => x.inwards.length > 0)
      .sort(
        (a, b) =>
          new Date(b.itemCreatedAt).getTime() -
          new Date(a.itemCreatedAt).getTime(),
      );
  }
  get outwardsByDate() {
    return Array.from(this.outwardsRegistry.values()).sort(
      (a, b) =>
        new Date(b.itemCreatedAt).getTime() -
        new Date(a.itemCreatedAt).getTime(),
    );
  }
  get deliveryByDate() {
    return Array.from(this.deliveryRegistry.values())
      .sort(
        (a, b) =>
          new Date(b.itemCreatedAt).getTime() -
          new Date(a.itemCreatedAt).getTime(),
      )
      .filter((deliver) => deliver.itemDeliveryRequest.length !== 0);
  }

  get activitiesByCategory() {
    return Array.from(this.activityRegistryAll.values());
  }

  get activityitemsByDate() {
    return Array.from(this.activityRegistry.values());
  }

  get groupedActivities() {
    return Object.entries(
      this.activitiesByCategory.reduce(
        (activities, activity) => {
          if (store.userStore.user?.customerName === 'LVPCMS') {
            if (
              activity.asset_tracking_status !== null &&
              activity.type !== 'Film Festival'
            ) {
              activities[activity.asset_tracking_status] = activities[
                activity.asset_tracking_status
              ]
                ? [...activities[activity.asset_tracking_status], activity]
                : [activity];
            }
            return activities;
          } else {
            if (activity.asset_tracking_status !== null) {
              activities[activity.asset_tracking_status] = activities[
                activity.asset_tracking_status
              ]
                ? [...activities[activity.asset_tracking_status], activity]
                : [activity];
            }
            return activities;
          }
        },
        {} as { [key: string]: Activity[] },
      ),
    );
  }
  get groupedActivitiesAll() {
    return Object.entries(
      this.activitiesByCategory.reduce(
        (activities, activity) => {
          if (store.userStore.user?.customerName === 'LVPCMS') {
            if (
              activity.asset_tracking_status !== null &&
              this.peopleSelected?.AssetIds?.includes(activity.id) &&
              activity.type !== 'Film Festival'
            ) {
              activities[activity.asset_tracking_status] = activities[
                activity.asset_tracking_status
              ]
                ? [...activities[activity.asset_tracking_status], activity]
                : [activity];
            }

            return activities;
          } else {
            if (
              activity.asset_tracking_status !== null &&
              this.peopleSelected?.AssetIds?.includes(activity.id)
            ) {
              activities[activity.asset_tracking_status] = activities[
                activity.asset_tracking_status
              ]
                ? [...activities[activity.asset_tracking_status], activity]
                : [activity];
            }

            return activities;
          }
        },
        {} as { [key: string]: Activity[] },
      ),
    );
  }

  getScannedDataAllocateUser = async (barcodeDetails: string[]) => {
    try {
      const data = await agent.Account.getScannedItems(barcodeDetails);
      if (data.data.length === 0) {
        toast.error('Scanned Items not available');
      }
      runInAction(() => (this.allocateUserTableData = data.data));
    } catch {
      toast.error('Something went wrong');
    }
  };

  enocoded_Uri_Data = (data: string) => {
    const uri = JSON.stringify(data);
    const encoded = encodeURI(uri);
    const myStr = encoded;
    const newStr = myStr
      .replace(/:/g, '%3A')
      .replace(/\//g, '%2F')
      .replace(/&/g, '%26');
    return newStr;
  };
  sendEmail = async (email: EmailNew, value: string,noToast?:boolean) => {
    try {
      await agent.email.sendNewEmail(email);
      runInAction(() => {
        store.emailStore.loadEmails();
      });
      if (value !== 'FromVerify' && !noToast) {
        toast.info('Email sent Successfully');
      }
    } catch (error) {
      console.log(error);
      runInAction(() => {
        this.loading = false;
      });
    }
  };
  private setActivity = (activity: Activity) => {
    const user = store.userStore.user;
    if (user) {
      activity.isHost = activity.hostUsername === user.username;
    }
    this.ActivityQuickscanData.push(activity);
    this.activityRegistry.set(activity.id, activity);
    this.activityRegistryBarcode.set(
      activity.physical_sensor_barcode,
      activity,
    );
    this.activityRegistryQrcode.set(activity.physical_sensor_qrcode, activity);
    this.activityRegistryrfid.set(activity.physical_sensor_RFID, activity);
  };

  private setActivityAll = (activity: Activity) => {
    if (activity.isDeleted === false) {
      const activityTitle = activity.id.split('/')[0];
      if (activityTitle !== 'undefined') {
        this.activityRegistryAll.set(activityTitle, activity);
      } else {
        this.activityRegistryAll.set(activity?.id, activity);
      }
      this.activityRegistryBarcode.set(
        activity.physical_sensor_barcode,
        activity,
      );
      this.activityRegistryQrcode.set(
        activity.physical_sensor_qrcode,
        activity,
      );
      this.activityRegistryrfid.set(activity.physical_sensor_RFID, activity);
    }
  };
  setActivityAllWithoutReload = (activity: any) => {
    this.setActivityAll(activity);
  };
  // activities store
  activitiesStore = (activities: Activity[]) => {
    this.activityRegistryAll = new Map<string, Activity>();
    // const user = store.userStore.user;
    runInAction(() => {
      activities.forEach((activity) => {
        // if (id) {
        this.setActivityAll(activity);
        // }
      });
      this.isActivity = true;
    });
    this.loadingActiviyAll = false;
  };
  itemGroupIdAPI = async () => {
    this.isFilterApiCalled = true;
    try {
      let groupIdCountsDetailsL =
        await agent.Activities.getItemGroupIdCountsAPI(this.Filter);
      this.groupIdCountsDetails = groupIdCountsDetailsL;
    } catch {
      this.isFilterApiCalled = false;
      this.loadingActiviyAll = false;
      toast.error('Oops!! unable to fetch the data');
    }
  };
  searchAndItemGroupsAndFilter = async () => {
    try {
      this.isFilterApiCalled = true;
      let activities: Activity[] = [];
      // let hasData = !!(this.Filter || this.FilterById || this.FilterCategory);
      if (this.Filter !== '') {
        this.FilterCategory = '';
      }
      activities = await agent.Activities.searchAndItemGroupsAndFilterAssetsAPI(
        this.Filter,
        this.FilterById,
        store.userStore?.user?.customerName !== 'Museum'
          ? this.FilterCategory.charAt(0).toUpperCase() +
              this.FilterCategory.slice(1)
                .replace(/([A-Z][a-z])/g, ' $1')
                .trim()
          : this.FilterCategory,
        this.currentPage,
        10,
      );
      if (!this.isThisFilterCategory) {
        let filterAssetsDetails: any =
          await agent.Activities.getFilterCountsAPI(
            this.Filter,
            this.FilterById,
            store.userStore?.user?.customerName !== 'Museum'
              ? this.FilterCategory.charAt(0).toUpperCase() +
                  this.FilterCategory.slice(1)
                    .replace(/([A-Z][a-z])/g, ' $1')
                    .trim()
              : this.FilterCategory,
          );
        // if (this.FilterCategory === '') {
        let countValue = 0;
        Object.entries(filterAssetsDetails).forEach(([group, count]) => {
          if (store.userStore.user?.customerName === 'Museum') {
            //   // if (this.FilterById !== '' && this.FilterCategory !== '') {
            //   //   if (group === 'currentCount') {
            //   //     countValue += count as number;
            //   //   }
            //   // } else {
            countValue += count as number;
            //   // }
          } else {
            if (group === 'currentCount') {
              countValue = count as number;
              return;
            }
          }
        });
        if (this.FilterCategory !== '') {
          this.filteredAssetsCount = filterAssetsDetails[this.FilterCategory];
        } else {
          this.filteredAssetsCount = countValue === 0 ? 1 : countValue;
        }
        // }
        this.filterAssetsDetails = filterAssetsDetails;
      }
      this.isThisFilterCategory = false;
      this.activitiesStore(activities);
      this.isFilterApiCalled = false;
    } catch {
      this.isFilterApiCalled = false;
      this.loadingActiviyAll = false;
      toast.error('Oops!! unable to fetch the data');
    }
  };
  initialAssetsFetchAPI = async () => {
    try {
      this.isFilterApiCalled = true;
      this.loadingActiviyAll = true;
      const activities =
        await agent.Activities.searchAndItemGroupsAndFilterAssetsAPI(
          '',
          '',
          '',
          1,
          10,
        );
      this.activitiesStore(activities);
      this.loadingActiviyAll = false;
      this.isFilterApiCalled = false;
    } catch (error) {
      toast.error('Oops!! Unable to fetch data');
      this.isFilterApiCalled = false;
      this.loadingActiviyAll = false;
    }
  };
  getAssetsPagination = async (
    pagenumber: number,
    id: string,
    pageSize: number,
  ) => {
    this.isFilterApiCalled = true;
    if (id !== undefined) {
      try {
        // this.activityRegistry=  new Map <string, Activity>();
        const activities =
          store.userStore.user?.customerName === 'LVPCMS'
            ? await agent.Activities.listPaginationLVP(id, pagenumber, pageSize)
            : await agent.Activities.listPagination({
                pageNo: pagenumber,
                pageSize: pageSize,
                searchDate: '',
              });
        this.activityRegistry = new Map<string, Activity>();
        runInAction(() => {
          this.activitiesStore(activities);
        });
        this.isFilterApiCalled = false;
      } catch (error) {
        console.log(error);
        this.isFilterApiCalled = false;
        this.setLoadingInitial(false);
      }
    }
  };
  loadActivities = async () => {
    try {
      this.loadingActiviyAll = true;
      const activities = await agent.Activities.list();
      this.activityRegistryAll = new Map<string, Activity>();
      // const user = store.userStore.user;
      runInAction(() => {
        activities.forEach((activity) => {
          // if (id) {
          this.setActivityAll(activity);

          // }
        });
        this.isActivity = true;
      });
      this.loadingActiviyAll = false;
    } catch (error) {
      console.log(error);
      this.loadingActiviyAll = false;
    }
  };

  loadTagPagination = async (pagenumber: number) => {
    try {
      //   //  ======= This is Receiving Tag pagenation resovled by kumaresan
      if (pagenumber === 1) store.dashboardStore.setTagPageNumFunc(pagenumber);

      this.loadTagLoading = true;
      // this.activityRegistry=  new Map <string, Activity>();
      const activities = await agent.Tag.listItemPagination(pagenumber);

      this.activityRegistry = new Map<string, Activity>();
      runInAction(() => {
        activities.forEach((activity) => {
          this.setActivity(activity);
          // this.isActivity = true;
        });
      });
      this.loadTagLoading = false;
    } catch (error) {
      console.log(error);
      this.setLoadingInitial(false);
    }
  };
  searchListTag = async (pagenumber: number, data: any) => {
    try {
      this.loadTagLoading = true;

      const search = function (data: any) {
        return new Promise(async (resolve) => {
          let result = await agent.Tag.searchList(pagenumber, data);
          resolve(result);
        });
      };

      const count = function (data: any) {
        return new Promise(async (resolve) => {
          const searchCount = await agent.Tag.searchCount(data);
          resolve(searchCount);
        });
      };

      let [activities, searchCount]: any = await Promise.all([
        search(this.enocoded_Uri_Data(data)),
        count(this.enocoded_Uri_Data(data)),
      ]);
      store.dashboardStore.dashboard.tagCount = searchCount.data;
      const resp = activities.data;
      this.activityRegistry = new Map<string, Activity>();
      runInAction(() => {
        resp.forEach((activity: Activity) => {
          this.setActivity(activity);

          // this.isActivity = true;
        });
      });
      this.loadTagLoading = false;
    } catch (error) {
      console.log(error);
      this.setLoadingInitial(false);
    }
  };
  sortListTag = async (data: any, order: string, pagenum: number) => {
    try {
      this.loadTagLoading = true;
      const activities = await agent.Tag.sortList(data, order, pagenum);
      this.activityRegistry = new Map<string, Activity>();
      runInAction(() => {
        activities.forEach((activity) => {
          this.setActivity(activity);
        });
      });
      this.loadTagLoading = false;
    } catch (error) {
      console.log(error);
      this.setLoadingInitial(false);
    }
  };
  loadCRPagination = async (pagenumber: number) => {
    try {
      //  ======= This is Receiving Create order pagenation resovled by kumaresan
      if (pagenumber === 1)
        store.dashboardStore.setCRTablePageNumFunc(pagenumber);

      this.loadCRLoading = true;
      // this.activityRegistry=  new Map <string, Activity>();
      const activities = await agent.CreateOrder.listItemPagination(
        pagenumber,
        5,
      );
      store.dashboardStore.createOrderCount();
      this.activityRegistry = new Map<string, Activity>();
      runInAction(() => {
        activities.forEach((activity) => {
          this.setActivity(activity);
          // this.isActivity = true;
        });
      });
      this.loadCRLoading = false;
    } catch (error) {
      console.log(error);
      this.setLoadingInitial(false);
    }
  };
  searchListCR = async (pagenumber: number, data: any) => {
    try {
      this.loadCRLoading = true;

      const activities = await agent.CreateOrder.searchList(
        pagenumber,
        this.enocoded_Uri_Data(data),
      );
      const searchCount = await agent.CreateOrder.searchCount(
        this.enocoded_Uri_Data(data),
      );
      store.dashboardStore.dashboard.CreateOrderCount = searchCount.data;
      const resp = activities.data;
      this.activityRegistry = new Map<string, Activity>();
      runInAction(() => {
        resp.forEach((activity) => {
          this.setActivity(activity);

          // this.isActivity = true;
        });
      });
      this.loadCRLoading = false;
    } catch (error) {
      console.log(error);
      this.setLoadingInitial(false);
    }
  };
  sortListCR = async (data: any, order: string, pagenum: number) => {
    try {
      this.loadCRLoading = true;
      const activities = await agent.CreateOrder.sortList(data, order, pagenum);
      this.activityRegistry = new Map<string, Activity>();
      runInAction(() => {
        activities.forEach((activity) => {
          this.setActivity(activity);
        });
      });
      this.loadCRLoading = false;
    } catch (error) {
      console.log(error);
      this.setLoadingInitial(false);
    }
  };

  HFCServiceCount= async()=>{
    try{
      const service = await agent.HFC.HFCServicesL3();
      this.ServiceCount = service.data
    }catch(error){
      console.log(error);
    }
  }

  replaceMultipleKeys = (obj: Activity, keyMap: Record<string, string>): Activity => {
    return Object.keys(obj).reduce((acc, key) => {
      const newKey = keyMap[key] || key;
      (acc as any)[newKey] = (obj as any)[key];
      return acc;
    }, {} as Activity);
  };
  loadActivitiesPagination = async (
    pagenumber: number,
    id: string,
    pageSize: number,
  ) => {
    if (id !== undefined) {
      try {
        this.loadCountAssetTable = true;
  
        const activities: Activity[] =
          store.userStore.user?.customerName === 'LVPCMS'
            ? await agent.Activities.listPaginationLVP(id, pagenumber, pageSize)
            : await agent.Activities.listPagination({
                pageNo: pagenumber,
                pageSize: pageSize,
                searchDate: '',
              });
  
        // Define the key map for replacement
        const keyMap = {
          'physical_sensor_barcode': 'new_hostname',
          'physical_sensor_RFID': 'workstation_no',
          'physical_location_vault': 'location',
          'physical_location_rack': 'company',
          'physical_location_shelf': 'building',
          'ftpPath': 'ip_address',
          'receiver': 'current_username',
        };
  
        // Conditionally replace keys for specific customer
        const updatedActivities: Activity[] = store.userStore.user?.customerName === 'PCPLIT'
          ? activities.map(activity =>
              this.replaceMultipleKeys(activity, keyMap)
            )
          : activities;
  
        this.activityRegistry = new Map<string, Activity>();
        if (pagenumber === 1) {
          store.dashboardStore.dashboard.setTagTablePageNumber = 1;
        }
  
        runInAction(() => {
          updatedActivities.forEach((activity) => {
            if(store.userStore.user?.customerName === 'PCPLCRM' && store.userStore.user?.roleName === 'IT Team') (activity.title = activity?.title?.split('~')[0]?.split('-')[0] || '')
            this.setActivity(activity);
            // this.isActivity = true;
          });
        });
  
        this.loadCountAssetTable = false;
      } catch (error) {
        console.log(error);
        this.setLoadingInitial(false);
        this.loadCountAssetTable = false;
      }
    }
  };

  MepzLoadActivities = async (pagenumber: number, pageSize: number, arr: any[]) => {
    this.loading = true; 
    try {
      const res = await agent.Activities.mepzItemFilter(pagenumber, pageSize, arr);
        store.dashboardStore.dashboard.inventoryCount2 = res.data.totalCount;
      runInAction(() => {
        this.mepzActivities = res.data.items.map((item: any) => {
          const consolidatedObject = item.metadata.reduce((acc: any, itm: any) => {
            acc[itm.elementName] = itm.elementValue;
            return acc;
          }, {});
          const formatKey = (key: string) => {
            const keyWithUnderscores = key.replace(/\s+/g, '_');
            return keyWithUnderscores.charAt(0).toLowerCase() + keyWithUnderscores.slice(1);
          };
          const orderedObject = {
            id: item.id,
            [formatKey("File Name")]: consolidatedObject["File Name"],
            [formatKey("Category")]: consolidatedObject["Category"] || "MEIS", 
            [formatKey("Department")]: consolidatedObject["Department"],
            [formatKey("Lot No")]: consolidatedObject["Lot No"],
            [formatKey("Company Name")]: consolidatedObject["Company Name"],
            [formatKey("License Number")]: consolidatedObject["License Number"]
          };
          return orderedObject;
        });
      });
    } catch (error) {
      console.error("Error fetching activities:", error);
    } finally {
      runInAction(() => {
        this.loading = false; 
      });
    }
  }

HFCloadActivitiesPagination = async (
  pagenumber: number,
  id: string,
  pageSize: number,
  newArr?: any[]
) => {
  if (id !== undefined) {
    try {
      this.loadCountAssetTable = true;
      const response = await agent.Activities.hfcInventoryList(pagenumber, pageSize, newArr !== undefined ? newArr : []);
      const activities = response.data.items;
      const keyMap = {
        'physical_sensor_barcode': 'reel_barcodes',
        'physical_sensor_RFID': 'asset_id',
        'physical_location_vault': 'vault',
        'physical_location_rack': 'aisle_no',
        'physical_location_shelf': 'shelf',
        'number_of_element':'print',
        'physical_sensor_qrcode':'container_barcodes',
      };
      const updatedActivities: Activity[] =  activities.map((activity:Activity) =>
              this.replaceMultipleKeys(activity, keyMap)
            )
      this.activityRegistry = new Map<string, Activity>();
      if (pagenumber === 1) {
        store.dashboardStore.dashboard.setTagTablePageNumber = 1;
      }
      runInAction(() => {
          let arr: any[] = [];
          updatedActivities.forEach((element:any) => {
            arr.push({
              ...element
            });
          });
          arr?.forEach((activity: any) => {
            this.setActivity(activity);
          });
          store.dashboardStore.dashboard.inventoryCount2 = response.data.totalCount;
      });
      this.loadCountAssetTable = false;
    } catch (error) {
      console.log(error);
      this.setLoadingInitial(false);
      this.loadCountAssetTable = false;
    }
  }
};


HFCVaultloadActivitiesPagination = async (
  pagenumber: number,
  id: string,
  pageSize: number,
  newArr?: any[]
) => {
  if (id !== undefined) {
    try {
      this.loadCountAssetTable = true;
      const response = await agent.Activities.hfcVaultInventoryList(pagenumber, pageSize, newArr !== undefined ? newArr : []);
      const reponse2 = await agent.Activities.hfcVaultCount(newArr !== undefined ? newArr : [])
      const activities = response.data;
      this.activityRegistry = new Map<string, Activity>();
      if (pagenumber === 1) {
        store.dashboardStore.dashboard.setTagTablePageNumber = 1;
      }
      runInAction(() => {
          let arr: any[] = [];
          activities.forEach((element:any) => {
            arr.push({
              ...element
            });
          });
          arr?.forEach((activity: any) => {
            this.setActivity(activity);
          });
          store.dashboardStore.dashboard.VaultCount = reponse2.data;
      });
      this.loadCountAssetTable = false;
    } catch (error) {
      console.log(error);
      this.setLoadingInitial(false);
      this.loadCountAssetTable = false;
    }
  }
};

HFCShipperloadActivitiesPagination = async (
  pagenumber: number,
  id: string,
  pageSize: number,
  newArr?: any[]
) => {
  if (id !== undefined) {
    try {
      this.loadCountAssetTable = true;
      const response = await agent.Activities.hfcShipperList(pagenumber, pageSize, newArr !== undefined ? newArr : []);
     const reponse2 = await agent.Activities.hfcShipperCount(newArr !== undefined ? newArr : [])
      const activities = response.data;
      this.activityRegistry = new Map<string, Activity>();
      if (pagenumber === 1) {
        store.dashboardStore.dashboard.setTagTablePageNumber = 1;
      }
      runInAction(() => {
          let arr: any[] = [];
          activities.forEach((element:any) => {
            arr.push({
              ...element
            });
          });
          arr?.forEach((activity: any) => {
            this.setActivity(activity);
          });
          store.dashboardStore.dashboard.shipperCount = reponse2.data;
      });

      this.loadCountAssetTable = false;
  } catch (error) {
      console.log(error);
      this.setLoadingInitial(false);
      this.loadCountAssetTable = false;
    }
  }
};


HFCPullloadActivitiesPagination = async (
  pagenumber: number,
  id: string,
  pageSize: number,
  newArr?: any[]
) => {
  if (id !== undefined) {
    try {
      this.loadCountAssetTable = true;
      const response = await agent.Activities.hfcPullList(pagenumber, pageSize, newArr !== undefined ? newArr : []);
     const reponse2 = await agent.Activities.hfcPullCount(newArr !== undefined ? newArr : [])
      const activities = response.data;
      this.activityRegistry = new Map<string, Activity>();
      if (pagenumber === 1) {
        store.dashboardStore.dashboard.setTagTablePageNumber = 1;
      }
      runInAction(() => {
          let arr: any[] = [];
          activities.forEach((element:any) => {
            arr.push({
              ...element
            });
          });
          arr?.forEach((activity: any) => {
            this.setActivity(activity);
          });
          store.dashboardStore.dashboard.pullCount = reponse2.data;
      });
      this.loadCountAssetTable = false;
    } catch (error) {
      console.log(error);
      this.setLoadingInitial(false);
      this.loadCountAssetTable = false;
    }
  }
};

HFCShippingPreploadActivitiesPagination = async (
  pagenumber: number,
  id: string,
  pageSize: number,
  newArr?: any[]
) => {
  if (id !== undefined) {
    try {
      this.loadCountAssetTable = true;
      const response = await agent.Activities.hfcShippinPrep(pagenumber, pageSize, newArr !== undefined ? newArr : []);
     const reponse2 = await agent.Activities.hfcShippinPrepCount(newArr !== undefined ? newArr : [])
      const activities = response.data;
      this.activityRegistry = new Map<string, Activity>();
      if (pagenumber === 1) {
        store.dashboardStore.dashboard.setTagTablePageNumber = 1;
      }
      runInAction(() => {
          let arr: any[] = [];
          activities.forEach((element:any) => {
            arr.push({
              ...element
            });
          });
          arr?.forEach((activity: any) => {
            this.setActivity(activity);
          });
          store.dashboardStore.dashboard.shippingPrepCount = reponse2.data;
      });
      this.loadCountAssetTable = false;
    } catch (error) {
      console.log(error);
      this.setLoadingInitial(false);
      this.loadCountAssetTable = false;
    }
  }
};

HFCShippingdeliveryloadActivitiesPagination = async (
  pagenumber: number,
  id: string,
  pageSize: number,
  newArr?: any[]
) => {
  if (id !== undefined) {
    try {
      this.loadCountAssetTable = true;
      const response = await agent.Activities.hfcShipping(pagenumber, pageSize, newArr !== undefined ? newArr : []);
     const reponse2 = await agent.Activities.hfcShippingCount(newArr !== undefined ? newArr : [])
      const activities = response.data;
      this.activityRegistry = new Map<string, Activity>();
      if (pagenumber === 1) {
        store.dashboardStore.dashboard.setTagTablePageNumber = 1;
      }
      runInAction(() => {
          let arr: any[] = [];
          activities.forEach((element:any) => {
            arr.push({
              ...element
            });
          });
          arr?.forEach((activity: any) => {
            this.setActivity(activity);
          });
          store.dashboardStore.dashboard.shippingCount = reponse2.data;
      });
      this.loadCountAssetTable = false;
    } catch (error) {
      console.log(error);
      this.setLoadingInitial(false);
      this.loadCountAssetTable = false;
    }
  }
};

HFCDeliveryRequest = async (
  pagenumber: number,
  id: string,
  pageSize: number,
  newArr?: any[]
) => {
  if (id !== undefined) {
    try {
      this.loadCountAssetTable = true;
      const response = await agent.Activities.hfcDeliveryrequest(pagenumber, pageSize, newArr !== undefined ? newArr : []);
      const reponse2 = await agent.Activities.hfcDeliveryrequestCount(newArr !== undefined ? newArr : [])
      const activities = response.data;
      this.activityRegistry = new Map<string, Activity>();
      if (pagenumber === 1) {
        store.dashboardStore.dashboard.setTagTablePageNumber = 1;
      }
      runInAction(() => {
          let arr: any[] = [];
          activities.forEach((element:any) => {
            arr.push({
              ...element
            });
          });
          arr?.forEach((activity: any) => {
            this.setActivity(activity);
          });
          store.dashboardStore.dashboard.movementCount = reponse2.data;
      });
      this.loadCountAssetTable = false;
    } catch (error) {
      console.log(error);
      this.setLoadingInitial(false);
      this.loadCountAssetTable = false;
    }
  }
};


HFCReceivingloadActivitiesPagination = async (
  pagenumber: number,
  id: string,
  pageSize: number,
  newArr?: any[]
) => {
  if (id !== undefined) {
    try {
      this.loadCountAssetTable = true;
      const response = await agent.Activities.hfcReceivingList(pagenumber, pageSize, newArr !== undefined ? newArr : []);
      const reponse2 = await agent.Activities.hfcReceivingCount(newArr !== undefined ? newArr : [])
      const activities = response.data;
      this.activityRegistry = new Map<string, Activity>();
      if (pagenumber === 1) {
        store.dashboardStore.dashboard.setTagTablePageNumber = 1;
      }
      runInAction(() => {
          let arr: any[] = [];
          activities.forEach((element:any) => {
            arr.push({
              ...element
            });
          });
          arr?.forEach((activity: any) => {
            this.setActivity(activity);
          });
          store.dashboardStore.dashboard.HFCReceivingCount = reponse2.data;
      });
      this.loadCountAssetTable = false;
    } catch (error) {
      console.log(error);
      this.setLoadingInitial(false);
      this.loadCountAssetTable = false;
    }
  }
};

HFCAssignTaskloadActivitiesPagination = async (
  pagenumber: number,
  id: string,
  pageSize: number,
  newArr?: any[]
) => {
  if (id !== undefined) {
    try {
      this.loadCountAssetTable = true;
      const response = await agent.Activities.hfcAssignList(pagenumber, pageSize, newArr !== undefined ? newArr : []);
      const reponse2 = await agent.Activities.hfcAssignCount(newArr !== undefined ? newArr : [])
      const activities = response.data;
      this.activityRegistry = new Map<string, Activity>();
      if (pagenumber === 1) {
        store.dashboardStore.dashboard.setTagTablePageNumber = 1;
      }
      runInAction(() => {
          let arr: any[] = [];
          activities.forEach((element:any) => {
            arr.push({
              ...element
            });
          });
          arr?.forEach((activity: any) => {
            this.setActivity(activity);
          });
          store.dashboardStore.dashboard.AssignCount = reponse2.data;
      });
      this.loadCountAssetTable = false;
    } catch (error) {
      console.log(error);
      this.setLoadingInitial(false);
      this.loadCountAssetTable = false;
    }
  }
};

HFCServiceloadActivitiesPagination = async (
  service: string,
  pagenumber: number,
  id: string,
  pageSize: number,
  newArr?: any[]
) => {
  if (id !== undefined) {
    try {
      this.loadCountAssetTable = true;
      const response = await agent.Activities.hfcServiceList(service,pagenumber, pageSize, newArr !== undefined ? newArr : []);
      const reponse2 = await agent.Activities.hfcServiceCount(service, newArr !== undefined ? newArr : [])
      const activities = response.data;
      this.activityRegistry = new Map<string, Activity>();
      if (pagenumber === 1) {
        store.dashboardStore.dashboard.setTagTablePageNumber = 1;
      }
      runInAction(() => {
          let arr: any[] = [];
          activities.forEach((element:any) => {
            arr.push({
              ...element
            });
          });
          arr?.forEach((activity: any) => {
            this.setActivity(activity);
          });
          store.dashboardStore.dashboard.HFCServiceCount = reponse2.data;
      });
      this.loadCountAssetTable = false;
    } catch (error) {
      console.log(error);
      this.setLoadingInitial(false);
      this.loadCountAssetTable = false;
    }
  }
};

HFCReturningloadActivitiesPagination = async (
  pagenumber: number,
  id: string,
  pageSize: number,
  newArr?: any[]
) => {
  if (id !== undefined) {
    try {
      this.loadCountAssetTable = true;
      const response = await agent.Activities.hfcReturnServiceList(pagenumber, pageSize, newArr !== undefined ? newArr : []);
      const reponse2 = await agent.Activities.hfcReturnServiceCount(newArr !== undefined ? newArr : [])
      const activities = response.data;
      this.activityRegistry = new Map<string, Activity>();
      if (pagenumber === 1) {
        store.dashboardStore.dashboard.setTagTablePageNumber = 1;
      }
      runInAction(() => {
          let arr: any[] = [];
          activities.forEach((element:any) => {
            arr.push({
              ...element
            });
          });
          arr?.forEach((activity: any) => {
            this.setActivity(activity);
          });
          store.dashboardStore.dashboard.HFCReturnCount = reponse2.data;
      });
      this.loadCountAssetTable = false;
    } catch (error) {
      console.log(error);
      this.setLoadingInitial(false);
      this.loadCountAssetTable = false;
    }
  }
};

fetchMepzUnsyncedActivities = async (
  pageNumber: number,
  pageSize: number
) => {
  // Ensure 'id' is defined before proceeding
 
  try {
    // Set loading state to true
    this.loadCountAssetTable = true;

    // Fetch data and count concurrently
    const [response, count] = await Promise.all([
      agent.Activities.mepzUnsyncData(pageNumber, pageSize),
      agent.Activities.mepzUnsyncDataCount()
    ]);

    // Update page number only if it's the first page
    if (pageNumber === 1) {
      store.dashboardStore.dashboard.setTagTablePageNumber = 1;
    }

    // Use runInAction to update the store in a transactional way
    runInAction(() => {
      store.dashboardStore.dashboard.unSyncedData = response.data;
      store.dashboardStore.dashboard.unsyncedCount = count.data;
    });

  } catch (error) {
    // Log error and update loading state
    console.error('Error fetching unsynced activities:', error);
    this.setLoadingInitial(false);
  } finally {
    // Ensure loading state is set to false regardless of success or failure
    this.loadCountAssetTable = false;
  }
};


fetchMepzsyncedActivities = async (
  pageNumber: number,
  pageSize: number
) => {
  // Ensure 'id' is defined before proceeding
 
  try {
    // Set loading state to true
    this.loadCountAssetTable = true;

    // Fetch data and count concurrently
    const [response, count] = await Promise.all([
      agent.Activities.mepzsyncData(pageNumber, pageSize),
      agent.Activities.mepzsyncDataCount()
    ]);

    // Update page number only if it's the first page
    if (pageNumber === 1) {
      store.dashboardStore.dashboard.setTagTablePageNumber = 1;
    }

    // Use runInAction to update the store in a transactional way
    runInAction(() => {
      store.dashboardStore.dashboard.syncedData = response.data;
      store.dashboardStore.dashboard.syncedCount = count.data;
    });

  } catch (error) {
    // Log error and update loading state
    console.error('Error fetching unsynced activities:', error);
    this.setLoadingInitial(false);
  } finally {
    // Ensure loading state is set to false regardless of success or failure
    this.loadCountAssetTable = false;
  }
};

searchListItems = async (item: any, pagenumber: number, pagesize: number) => {
  try {
      this.loadCountAssetTable = true;

      // Define the key map for replacement
      const keyMap = {
          'physical_sensor_barcode': 'new_hostname',
          'physical_sensor_RFID': 'workstation_no',
          'physical_location_vault': 'location',
          'physical_location_rack': 'company',
          'physical_location_shelf': 'building',
          'ftpPath': 'ip_address',
          'receiver': 'current_username',
      };

      // Reverse the key map only for PCPLIT customer
      const reverseKeyMap = store.userStore.user?.customerName === 'PCPLIT'
          ? Object.fromEntries(
              Object.entries(keyMap).map(([key, value]) => [value, key])
            )
          : {};

      // Apply key replacement to the search item if needed
      const updatedItem = store.userStore.user?.customerName === 'PCPLIT'
          ? this.replaceMultipleKeys(item, reverseKeyMap)
          : item;

      // Prepare search parameters
      const searchDate = updatedItem === null || updatedItem === undefined ? '' : JSON.stringify(updatedItem)
      let params = {
          searchDate,
          pageNo: pagenumber,
          pageSize: pagesize,
      };

      // Fetch activities and inventory count
      const activities = await agent.Activities.listPagination(params);
      const countData = await agent.Activities.inventoryCount(
        updatedItem === undefined ? '' : this.enocoded_Uri_Data(updatedItem), // Ensure that you use updatedItem here
      );

      // Conditionally replace keys for specific customer
      const updatedActivities: Activity[] = store.userStore.user?.customerName === 'PCPLIT'
          ? activities.map(activity =>
              this.replaceMultipleKeys(activity, keyMap)
            )
          : activities;

      // Handle pagination page number
      if (pagenumber === 1) {
          store.dashboardStore.setTagPageNumFunc(1);
      }

      // Update activity registry and dashboard store
      this.activityRegistry = new Map<string, Activity>();
      runInAction(() => {
          store.dashboardStore.dashboard.inventoryCount2 = countData;
          updatedActivities?.forEach((activity: Activity) => {
            if(store.userStore.user?.customerName === 'PCPLCRM' && store.userStore.user?.roleName === 'IT Team') (activity.title = activity?.title?.split('~')[0]?.split('-')[0] || '')
              this.setActivity(activity);
              if (
                  store.QuickScanStore.quickScanbarcodeInfo !== undefined &&
                  activity !== undefined
              ) {
                  store.QuickScanStore.quickScanbarcodeInfo = activity;
              }
              // this.isActivity = true;
          });
      });

      this.loadCountAssetTable = false;
  } catch (error) {
      console.log(error);
      this.loadCountAssetTable = false;
      this.setLoadingInitial(false);
  }
};

  HFCsearchListItems = async (item: any, pagenumber: number, pagesize: number) => {
    try {
      this.loadCountAssetTable = true;
      let params = {
        searchDate: item,
        pageNo: pagenumber,
        pageSize: pagesize,
      };
      const activities = await agent.Activities.hfcInventoryList(params.pageNo, params.pageSize, params.searchDate);
      const countData = await agent.Activities.hfcInventoryCount(item);
      if (pagenumber === 1) {
        store.dashboardStore.setTagPageNumFunc(1);
      }
      this.activityRegistry = new Map<string, Activity>();
      runInAction(() => {
        store.dashboardStore.dashboard.inventoryCount2 = countData.data;
        activities.data?.forEach((activity: Activity) => {
          this.setActivity(activity);
          if (
            store.QuickScanStore.quickScanbarcodeInfo !== undefined &&
            activity !== undefined
          ) {
            store.QuickScanStore.quickScanbarcodeInfo = activity;
          }
          // this.isActivity = true;
        });
      });
      this.loadCountAssetTable = false;
    } catch (error) {
      console.log(error);
      this.loadCountAssetTable = false;
      this.setLoadingInitial(false);
    }
  };

  HFCShippersearchListItems= async (item: any, pagenumber: number, pagesize: number) => {
    try {
      this.loadCountAssetTable = true;
      let params = {
        searchDate: item,
        pageNo: pagenumber,
        pageSize: pagesize,
      };
      const activities = await agent.Activities.hfcShipperList(params.pageNo, params.pageSize, params.searchDate);
      const countData = await agent.Activities.hfcShipperCount(item);
      if (pagenumber === 1) {
        store.dashboardStore.setTagPageNumFunc(1);
      }
      this.activityRegistry = new Map<string, Activity>();
      runInAction(() => {
        store.dashboardStore.dashboard.inventoryCount2 = countData.data;
        activities.data?.forEach((activity: Activity) => {
          this.setActivity(activity);
          if (
            store.QuickScanStore.quickScanbarcodeInfo !== undefined &&
            activity !== undefined
          ) {
            store.QuickScanStore.quickScanbarcodeInfo = activity;
          }
          // this.isActivity = true;
        });
      });
      this.loadCountAssetTable = false;
    } catch (error) {
      console.log(error);
      this.loadCountAssetTable = false;
      this.setLoadingInitial(false);
    }
  };

  HFCPullsearchListItems= async (item: any, pagenumber: number, pagesize: number) => {
    try {
      this.loadCountAssetTable = true;
      let params = {
        searchDate: item,
        pageNo: pagenumber,
        pageSize: pagesize,
      };
      const activities = await agent.Activities.hfcPullList(params.pageNo, params.pageSize, params.searchDate);
      const countData = await agent.Activities.hfcPullCount(item);
      if (pagenumber === 1) {
        store.dashboardStore.setTagPageNumFunc(1);
      }
      this.activityRegistry = new Map<string, Activity>();
      runInAction(() => {
        store.dashboardStore.dashboard.inventoryCount2 = countData.data;
        activities.data?.forEach((activity: Activity) => {
          this.setActivity(activity);
          if (
            store.QuickScanStore.quickScanbarcodeInfo !== undefined &&
            activity !== undefined
          ) {
            store.QuickScanStore.quickScanbarcodeInfo = activity;
          }
          // this.isActivity = true;
        });
      });
      this.loadCountAssetTable = false;
    } catch (error) {
      console.log(error);
      this.loadCountAssetTable = false;
      this.setLoadingInitial(false);
    }
  };

  HFCPrepsearchListItems= async (item: any, pagenumber: number, pagesize: number) => {
    try {
      this.loadCountAssetTable = true;
      let params = {
        searchDate: item,
        pageNo: pagenumber,
        pageSize: pagesize,
      };
      const activities = await agent.Activities.hfcShippinPrep(params.pageNo, params.pageSize, params.searchDate);
      const countData = await agent.Activities.hfcShippinPrepCount(item);
      if (pagenumber === 1) {
        store.dashboardStore.setTagPageNumFunc(1);
      }
      this.activityRegistry = new Map<string, Activity>();
      runInAction(() => {
        store.dashboardStore.dashboard.inventoryCount2 = countData.data;
        activities.data?.forEach((activity: Activity) => {
          this.setActivity(activity);
          if (
            store.QuickScanStore.quickScanbarcodeInfo !== undefined &&
            activity !== undefined
          ) {
            store.QuickScanStore.quickScanbarcodeInfo = activity;
          }
          // this.isActivity = true;
        });
      });
      this.loadCountAssetTable = false;
    } catch (error) {
      console.log(error);
      this.loadCountAssetTable = false;
      this.setLoadingInitial(false);
    }
  };

  HFCShippingsearchListItems= async (item: any, pagenumber: number, pagesize: number) => {
    try {
      this.loadCountAssetTable = true;
      let params = {
        searchDate: item,
        pageNo: pagenumber,
        pageSize: pagesize,
      };
      const activities = await agent.Activities.hfcShipping(params.pageNo, params.pageSize, params.searchDate);
      const countData = await agent.Activities.hfcShippingCount(item);
      if (pagenumber === 1) {
        store.dashboardStore.setTagPageNumFunc(1);
      }
      this.activityRegistry = new Map<string, Activity>();
      runInAction(() => {
        store.dashboardStore.dashboard.inventoryCount2 = countData.data;
        activities.data?.forEach((activity: Activity) => {
          this.setActivity(activity);
          if (
            store.QuickScanStore.quickScanbarcodeInfo !== undefined &&
            activity !== undefined
          ) {
            store.QuickScanStore.quickScanbarcodeInfo = activity;
          }
          // this.isActivity = true;
        });
      });
      this.loadCountAssetTable = false;
    } catch (error) {
      console.log(error);
      this.loadCountAssetTable = false;
      this.setLoadingInitial(false);
    }
  };

  HFCDeliverysearchListItems= async (item: any, pagenumber: number, pagesize: number) => {
    try {
      this.loadCountAssetTable = true;
      let params = {
        searchDate: item,
        pageNo: pagenumber,
        pageSize: pagesize,
      };
      const activities = await agent.Activities.hfcDeliveryrequest(params.pageNo, params.pageSize, params.searchDate);
      const countData = await agent.Activities.hfcDeliveryrequestCount(item);
      if (pagenumber === 1) {
        store.dashboardStore.setTagPageNumFunc(1);
      }
      this.activityRegistry = new Map<string, Activity>();
      runInAction(() => {
        store.dashboardStore.dashboard.inventoryCount2 = countData.data;
        activities.data?.forEach((activity: Activity) => {
          this.setActivity(activity);
          if (
            store.QuickScanStore.quickScanbarcodeInfo !== undefined &&
            activity !== undefined
          ) {
            store.QuickScanStore.quickScanbarcodeInfo = activity;
          }
          // this.isActivity = true;
        });
      });
      this.loadCountAssetTable = false;
    } catch (error) {
      console.log(error);
      this.loadCountAssetTable = false;
      this.setLoadingInitial(false);
    }
  };
  
  HFCReceivingsearchListItems= async (item: any, pagenumber: number, pagesize: number) => {
    try {
      this.loadCountAssetTable = true;
      let params = {
        searchDate: item,
        pageNo: pagenumber,
        pageSize: pagesize,
      };
      const activities = await agent.Activities.hfcReceivingList(params.pageNo, params.pageSize, params.searchDate);
      const countData = await agent.Activities.hfcReceivingCount(item);
      if (pagenumber === 1) {
        store.dashboardStore.setTagPageNumFunc(1);
      }
      this.activityRegistry = new Map<string, Activity>();
      runInAction(() => {
        store.dashboardStore.dashboard.inventoryCount2 = countData.data;
        activities.data?.forEach((activity: Activity) => {
          this.setActivity(activity);
          if (
            store.QuickScanStore.quickScanbarcodeInfo !== undefined &&
            activity !== undefined
          ) {
            store.QuickScanStore.quickScanbarcodeInfo = activity;
          }
          // this.isActivity = true;
        });
      });
      this.loadCountAssetTable = false;
    } catch (error) {
      console.log(error);
      this.loadCountAssetTable = false;
      this.setLoadingInitial(false);
    }
  };

  HFCAssignsearchListItems= async (item: any, pagenumber: number, pagesize: number) => {
    try {
      this.loadCountAssetTable = true;
      let params = {
        searchDate: item,
        pageNo: pagenumber,
        pageSize: pagesize,
      };
      const activities = await agent.Activities.hfcAssignList(params.pageNo, params.pageSize, params.searchDate);
      const countData = await agent.Activities.hfcAssignCount(item);
      if (pagenumber === 1) {
        store.dashboardStore.setTagPageNumFunc(1);
      }
      this.activityRegistry = new Map<string, Activity>();
      runInAction(() => {
        store.dashboardStore.dashboard.inventoryCount2 = countData.data;
        activities.data?.forEach((activity: Activity) => {
          this.setActivity(activity);
          if (
            store.QuickScanStore.quickScanbarcodeInfo !== undefined &&
            activity !== undefined
          ) {
            store.QuickScanStore.quickScanbarcodeInfo = activity;
          }
          // this.isActivity = true;
        });
      });
      this.loadCountAssetTable = false;
    } catch (error) {
      console.log(error);
      this.loadCountAssetTable = false;
      this.setLoadingInitial(false);
    }
  };

  HFCservicesearchListItems= async (item: any, pagenumber: number, pagesize: number) => {
    try {
      this.loadCountAssetTable = true;
      let params = {
        searchDate: item,
        pageNo: pagenumber,
        pageSize: pagesize,
      };
      const activities = await agent.Activities.hfcServiceList(dashboardStore.dashboard.valueForL4Orders, params.pageNo, params.pageSize, params.searchDate);
      const countData = await agent.Activities.hfcServiceCount(dashboardStore.dashboard.valueForL4Orders, item);
      if (pagenumber === 1) {
        store.dashboardStore.setTagPageNumFunc(1);
      }
      this.activityRegistry = new Map<string, Activity>();
      runInAction(() => {
        store.dashboardStore.dashboard.inventoryCount2 = countData.data;
        activities.data?.forEach((activity: Activity) => {
          this.setActivity(activity);
          if (
            store.QuickScanStore.quickScanbarcodeInfo !== undefined &&
            activity !== undefined
          ) {
            store.QuickScanStore.quickScanbarcodeInfo = activity;
          }
          // this.isActivity = true;
        });
      });
      this.loadCountAssetTable = false;
    } catch (error) {
      console.log(error);
      this.loadCountAssetTable = false;
      this.setLoadingInitial(false);
    }
  };

  searchListItemsLVPMSCount = async () => {
    try {
      this.loadCountAssetTable = true;
      const countData = await agent.Activities.searchListLVPMS();
      runInAction(() => {
        store.dashboardStore.dashboard.inventoryCount2 = countData || 0;
      });
      this.loadCountAssetTable = false;
    } catch (error) {
      console.log(error);
      this.loadCountAssetTable = false;
      this.setLoadingInitial(false);
    }
  };
  searchListFF = async (pagenumber: number, data: any) => {
    try {
      this.loadCountAssetTable = true;
      const activities = await agent.Activities.searchListFF(pagenumber, data);
      const resp = activities.data;
      this.activityRegistry = new Map<string, Activity>();
      runInAction(() => {
        resp.forEach((activity) => {
          this.setActivity(activity);
          // this.isActivity = true;
        });
      });
      this.loadCountAssetTable = false;
    } catch (error) {
      console.log(error);
      this.loadCountAssetTable = false;
      this.setLoadingInitial(false);
    }
  };
  sortListItems = async (
    data: string,
    order: string,
    pagenum: number,
    pagesize: number,
) => {
    try {
        this.loadCountAssetTable = true;

        // Define the key map for replacement
        const keyMap = {
            'physical_sensor_barcode': 'new_hostname',
            'physical_sensor_RFID': 'workstation_no',
            'physical_location_vault': 'location',
            'physical_location_rack': 'company',
            'physical_location_shelf': 'building',
            'ftpPath': 'ip_address',
            'receiver': 'current_username',
        };

        // Create reverse key map only for PCPLIT customer
        const reverseKeyMap = store.userStore.user?.customerName === 'PCPLIT'
            ? Object.fromEntries(
                Object.entries(keyMap).map(([key, value]) => [value, key])
              ):
              store.userStore.user?.customerName === 'PCPLCRM' && store.userStore.user.roleName === 'IT Team' ? 
            Object.fromEntries(
              Object.entries(sortNameReset).map(([key, value]) => [value, key])
            )
            : {};

        // Adjust data parameter if needed for PCPLIT
        const apiData = reverseKeyMap[data] || data;

        // Handle customer-specific logic for data field (for other cases)
        if (apiData === 'Asset_id' || apiData === 'asset_id') {
            if (store?.userStore?.user?.customerName === 'NFAI') {
                // Specific logic for NFAI customer
                data = 'physical_sensor_NFC'; // Ensure you use 'data' for customer-specific logic
            }
        }

        // Handle pagination page number
        if (pagenum === 1) {
            store.dashboardStore.dashboard.setTagTablePageNumber = 1;
        }

        // Fetch sorted activities
        const activitiesResponse = await agent.Activities.inventorySortData(
            apiData,
            order,
            pagenum,
            pagesize,
        );

        // Conditionally replace keys for specific customer
        const updatedActivities: Activity[] = store.userStore.user?.customerName === 'PCPLIT'
            ? activitiesResponse.map((activity: Activity) =>
                this.replaceMultipleKeys(activity, keyMap)
            )
            : activitiesResponse;

        // Update activity registry
        this.activityRegistry = new Map<string, Activity>();
        runInAction(() => {
            updatedActivities.forEach((activity: Activity) => {
              if(store.userStore.user?.customerName === 'PCPLCRM' && store.userStore.user?.roleName === 'IT Team') (activity.title = activity?.title?.split('~')[0]?.split('-')[0] || '')
                this.setActivity(activity);
            });
        });

        this.loadCountAssetTable = false;
    } catch (error) {
        console.log(error);
        this.loadCountAssetTable = false;
        this.setLoadingInitial(false);
    }
};


  HFCsortListItems = async (
    data: any,
    order: boolean,
    pagenum: number,
    pagesize: number,
  ) => {
    try {
      this.loadCountAssetTable = true;
      if (
        (data === 'Asset_id' || data === 'asset_id') &&
        store?.userStore?.user?.customerName === 'NFAI'
      ) {
        // static code for NFAI
        data = 'physical_sensor_NFC';
      }
      if (pagenum === 1) {
        store.dashboardStore.dashboard.setTagTablePageNumber = 1;
      }
      const activities = await agent.Activities.HFCinventorySortData(
        data,
        order,
        pagenum,
        pagesize,
      );
      this.activityRegistry = new Map<string, Activity>();
      runInAction(() => {
        activities.forEach((activity) => {
          this.setActivity(activity);
        });
      });
      this.loadCountAssetTable = false;
    } catch (error) {
      console.log(error);
      this.loadCountAssetTable = false;
      this.setLoadingInitial(false);
    }
  };

  

  sortListItemsNotFF = async (data: any, order: string, pagenum: number) => {
    try {
      this.loadCountAssetTable = true;
      const activities = await agent.Activities.sortNotFFList(
        data,
        order,
        pagenum,
      );
      this.activityRegistry = new Map<string, Activity>();
      runInAction(() => {
        activities.forEach((activity) => {
          this.setActivity(activity);
        });
      });
      this.loadCountAssetTable = false;
    } catch (error) {
      console.log(error);
      this.loadCountAssetTable = false;
      this.setLoadingInitial(false);
    }
  };

  getInwardRequestItem = async (id: any) => {
    this.loadingInitial = true;
    try {
      const response = await agent.Inwards.getInwardRequestItem(id);
      if (typeof response.data !== 'string') {
        this.setActivity(response.data);
      }
      runInAction(() => {
        if (typeof response.data !== 'string') {
          this.selectedActivity = response.data;
        }
      });
      this.loadingInitial = false;
      if (typeof response.data === 'string') {
        return response.data;
      } else {
        return '';
      }
    } catch {
      this.setLoadingInitial(false);
    }
  };

  replaceMultipleKeysobj = (data: Activity, keyMap: Record<string, string>): Activity => {
    
    const newData: Partial<Activity> = {}; // Create a new object to hold the transformed data
    
    for (const key of Object.keys(data)) {
      const newKey = keyMap[key] || key; // Find the new key in the keyMap, or use the old key if not present in keyMap
      
      // Use type assertion to avoid TypeScript error
      newData[newKey as keyof Activity] = data[key as keyof Activity]; // Assign the value to the new key
    }
    
    return newData as Activity; // Return the transformed data
  };
  


  loadActivity = async (id: any, status?: string) => {
    // this.loading=true;
    this.loadingInitial = true;
    try {
      if (id) {
        const activityResponse = await agent.Activities.details(id);
        let activity: Activity = activityResponse.data;

        // this api call for smart tracker
        store.TrackingReportStore.statusButtonShow(status || '');
        const keyMap = {
          'physical_sensor_barcode': 'new_hostname',
          'physical_sensor_RFID': 'workstation_no',
          'physical_location_vault': 'location',
          'physical_location_rack': 'company',
          'physical_location_shelf': 'building',
          'ftpPath': 'ip',
          'receiver': 'current_username',
      };

      const keyhfcMap ={
        'physical_sensor_qrcode': 'container_Barcodes',
        'physical_sensor_barcode': 'reel_Barcodes',
        'physical_sensor_RFID': 'asset_Id',
        'itemCreatedAt' :'created_At'
      }

      // Conditionally replace keys for specific customer
      if (store.userStore.user?.customerName === 'PCPLIT') {
        activity = this.replaceMultipleKeysobj(activity, keyMap);
      }
      if(store.commonStore.hfcCustomerChanges){
        activity = this.replaceMultipleKeysobj(activity, keyhfcMap);
      }
        this.setActivity(activity);
        runInAction(() => {
          this.activeTask = activity;
          this.selectedActivity = activity;
        });
        
        // this.setLoadingInitial(false);
        this.loadingInitial = false;
        return activity;
      }
    } catch (error) {
      console.log(error);
      this.setLoadingInitial(false);
    }
  };

  // HFCloadActivity = async (id: any, status?: string) => {
  //   // this.loading=true;
  //   this.loadingInitial = true;
  //   try {
  //     if (id) {
  //       const activity = await agent.Activities.HFCdetails(id);
  //       this.setActivity(activity.data);
  //       runInAction(() => {
  //         this.activeTask = activity.data;
  //         this.selectedActivity = activity.data;
  //       });
  //       // this.setLoadingInitial(false);
  //       this.loadingInitial = false;
  //       return activity;
  //     }
  //   } catch (error) {
  //     console.log(error);
  //     this.setLoadingInitial(false);
  //   }
  // };

  //production planning
  loadProduction = async () => {
    try {
      this.loadProductionTable = true;
      const isCustomer = store.userStore.user?.customerName==="NFAIReport";
      // this.activityRegistry = new Map<string, Activity>();
      const response = isCustomer ? 
      await agent.NFAI.NFAILevel2() : 
      await agent.ProdPlanning.listProductionType()
     if(isCustomer){
        const order:any = {
          "Data Management": 1,
          "Base Grade": 2,
          "AV Sync": 3,
          "Final Restoration": 4,
          "Color Grading": 5
        };

        this.typeProduction = response.data.sort((a:any, b:any) => order[a.task] - order[b.task]);

     }else {
       this.typeProduction = response.data
     }

      // if (response.data.length === 0) {
      //   this.activityRegistry?.clear();
      // }
      this.loadProductionTable = false;
    } catch (err) {
      this.loadProductionTable = false;
    }
  };
  loadProductionTask = async (type: string) => {
    try {
      if (type !== '') {
        this.loadProductionTable = true;
        // this.activityRegistry = new Map<string, Activity>();
        const isCustomer = store.userStore.user?.customerName === "NFAIReport"
        const response =  isCustomer ? 
        // await agent.ProdPlanning.NFAIListProductionTask(type) 
        await agent.NFAI.NFAILevel3(type)
        : await agent.ProdPlanning.listProductionTask(type)
        this.taskTypeProduction = response.data;
        // if (response.data.length === 0) {
        //   this.activityRegistry?.clear();
        // }
      }
      this.loadProductionTable = false;
      // let datas= JSON.parse(response.data);
    } catch {
      toast.error('Please try again.');
      this.loadProductionTable = false;
    }
  };
   NFAIRestorationProductionPlanningSearch = async (
  initialPostFilteredItemDetails: PostFilteredItemDetailsTypes
) => {
  try {
    this.loadProductionTable = true;

    const { PageNumber } = initialPostFilteredItemDetails;
    if (PageNumber === 1) {
      store.dashboardStore.setProdDataPageNum(PageNumber);
    }

    const { data } = await agent.NFAI.PostFilteredItemDetails(initialPostFilteredItemDetails);

    let count = 0;
    if (PageNumber === 1) {
      const countResponse = await agent.NFAI.GetFilteredItemDetailscount(initialPostFilteredItemDetails);
      count = countResponse.data;
    }

    runInAction(() => {
      this.activityRegistry = new Map<string, Activity>();

      const activities = addPreviousTasksAndSubtasks(data as any);
      activities?.forEach((activity: any) => {
        this.setActivity(activity);
      });

      if (PageNumber === 1) {
        store.dashboardStore.dashboard.prodPlanTableLength = count;
      }

      this.loadProductionTable = false;
    });
  } catch (err) {
    this.loadProductionTable = false;
    console.error("Error in NFAIRestorationProductionPlanningSearch:", err);
  }
};

  loadProductionPagination = async (
    type: string,
    task: string,
    pagenum: number,
  ) => {
    try {
      this.loadProductionTable = true;
      let payload = {
        currentTask: type,
        currentSubTask: task,
        PageNumber: pagenum,
        PageSize: 5,
      };
      if (pagenum === 1) store.dashboardStore.setProdDataPageNum(pagenum);
      
      const response:any = await agent.ProdPlanning.listProductionPlanning(payload)
      // ? await agent.ProdPlanning.NFAIListProductionPlanning(payload)
      this.activityRegistry = new Map<string, Activity>();
      runInAction(() => {
          response?.data?.forEach((activity:any) => {
            this.setActivity(activity);
          });
      });
      this.loadProductionTable = false;
    } catch (err) {
      this.loadProductionTable = false;
    }
  };
  searchProductionPlanning = async (
    type: string,
    task: string,
    data: any,
    pagenum: number,
  ) => {
    try {
      this.loadProductionTable = true;
      let containsValue = Object.values(data || {})?.filter((data) => data);
      let params = {
        currentTask: type,
        currentSubTask: task,
        searchvalue: containsValue?.length ? JSON.stringify(data) : '',
        PageNumber: pagenum,
        PageSize: 5,
      };
      const response =
        await agent.ProdPlanning.searchProductionPlanning(params);
      const countData = await agent.ProdPlanning.searchCountProduction(params);
      if (pagenum === 1) {
        store.dashboardStore.setProdDataPageNum(1);
      }
      this.activityRegistry = new Map<string, Activity>();
      runInAction(() => {
        store.dashboardStore.dashboard.prodPlanTableLength = countData.data;
        response.data?.forEach((activity) => {
          this.setActivity(activity);
        });
      });
      this.loadProductionTable = false;
    } catch (err) {
      this.loadProductionTable = false;
    }
  };
  sortProductionPlanning = async (
    type: string,
    task: string,
    order: string,
    name: string,
    pagenum: number,
  ) => {
    try {
      this.loadProductionTable = true;
      // let containsValue = Object.values(data || {})?.filter((data) => data);
      let params: any = {
        currentTask: type,
        currentSubTask: task,
        orderBy: name,
        name: order,
        PageNumber: pagenum,
        PageSize: 5,
      };
      // let params = {
      //     currentTask: type,
      //     currentSubTask: task,
      //     searchvalue: containsValue?.length ? data : "",
      //     PageNumber: pagenum,
      //     PageSize: 5
      // }
      const response = await agent.ProdPlanning.sortProductionPlanning(params);
      params['searchvalue'] = '';
      delete params['orderBy'];
      delete params['name'];
      const countData = await agent.ProdPlanning.searchCountProduction(params);
      // const countData= await agent.ProdPlanning.searchCountProduction(type,task,this.enocoded_Uri_Data(data));

      this.activityRegistry = new Map<string, Activity>();
      runInAction(() => {
        response.data?.forEach((activity) => {
          this.setActivity(activity);
          store.dashboardStore.dashboard.prodPlanTableLength = countData.data;
        });
      });
      this.loadProductionTable = false;
    } catch (err) {
      this.loadProductionTable = false;
    }
  };

  loadAttachmentHistory = async (id: any) => {
    try {
      const fileDetails = await agent.Activities.attachmentHistory(id);
      runInAction(() => {
        this.historyAttachmentFiles = fileDetails;
      });
      return fileDetails;
    } catch (error) {
      console.log(error);
    }
  };

  loadVoiceClipHistory = async (id: any) => {
    try {
      const fileDetails = await agent.Activities.voiceHistory(id);
      runInAction(() => {
        this.fileDataVoice = fileDetails;
      });
      return fileDetails;
    } catch (error) {
      console.log(error);
    }
  };

  loadMovementHistory = async (id: string) => {
    try {
      const movementtrackdetails: any = await agent.Activities.movementview(id);
      runInAction(() => {
        if (
          movementtrackdetails.data.length <= 0 ||
          movementtrackdetails.data ===
            'No Gate History Information is found' ||
          movementtrackdetails.data === 'Item not found'
        ) {
          return (this.movementtracker = []);
        } else {
          return (this.movementtracker = movementtrackdetails.data);
        }
      });
    } catch (error) {
      console.log(error, 'errror');
    }
  };
  //usertracker
  loadUserTracker = async (id: string) => {
    try {
      const usertrackdetails: any = await agent.Activities.usertracker(id);
      runInAction(() => {
        if (
          usertrackdetails.length <= 0 ||
          usertrackdetails === 'No User History Information is found' ||
          usertrackdetails === 'Item not found'
        ) {
          return (this.usertracker = []);
        } else {
          return (this.usertracker = usertrackdetails);
        }
      });
    } catch (error) {
      console.log(error);
    }
  };

  loadTimeDiff = async (userID: any) => {
    this.loading = true;
    try {
      await agent.Activities.timedifference(this.selectedActivity!.id, userID);
      runInAction(() => {
        const newArr: any = {
          ...this.selectedActivity,
        };
        this.selectedActivity = newArr;
        this.activityRegistry.set(this.selectedActivity!.id, userID);
      });
    } catch (error) {
      console.log(error);
    } finally {
      runInAction(() => (this.loading = false));
    }
  };

  viewHistorySearch = async (
    itemId: string,
    values: string,
    pageNumber: number,
    pageSize: number,
  ) => {
    try {
      this.isViewHistoryLoading = true;
      let params: any = {
        itemid: itemId,
        values: values || null,
        PageNumber: pageNumber,
        PageSize: pageSize,
      };
      let [historyDetails, searchCount] = await Promise.all([
        agent.Activities.viewHistorySearchAPI(params),
        agent.Activities.viewHistoryCountAPI({
          itemid: itemId,
          values: values || null,
        }),
      ]);
      runInAction(() => {
        this.historyData = historyDetails.data;
        this.historyCount = searchCount.data;
      });
      this.isViewHistoryLoading = false;
    } catch (error) {
      this.isViewHistoryLoading = false;
    }
  };
  viewHistorySort = async (params: {
    itemid: string;
    sortvalue: string;
    sortby: string;
    PageNumber: number;
    PageSize: number;
  }) => {
    try {
      this.isViewHistoryLoading = true;
      const historyDetails = await agent.Activities.viewHistorySortAPI(params);
      runInAction(() => {
        this.historyData = historyDetails.data;
      });
      this.isViewHistoryLoading = false;
    } catch (error) {
      this.isViewHistoryLoading = false;
    }
  };
  // view template
  viewTemplateSearch = async (
    itemId: string,
    values: string,
    pageNumber: number,
    pageSize: number,
  ) => {
    try {
      this.isViewTemplateLoading = true;
      let params = {
        ItemId: itemId,
        searchvalue: values,
        PageNumber: pageNumber,
        PageSize: pageSize,
      };
      let countParams = {
        ItemId: itemId,
        searchvalue: values,
      };
      const templateDetails =
        await agent.Activities.viewTemplateSearchAPI(params);
      const searchCount =
        await agent.Activities.viewTemplateCountAPI(countParams);
      runInAction(() => {
        this.viewTemplateOrderDetails = templateDetails.data;
        this.viewTemplateCount = searchCount.data;
      });
      this.isViewTemplateLoading = false;
    } catch (error) {
      this.isViewTemplateLoading = false;
    }
  };
  viewTemplateSort = async (params: {
    ItemId: string;
    SortValue: string;
    SortBy: string;
    PageNumber: number;
    PageSize: number;
  }) => {
    try {
      this.isViewTemplateLoading = true;
      const viewTemplateDetails =
        await agent.Activities.viewTemplateSortAPI(params);
      runInAction(() => {
        this.viewTemplateOrderDetails = viewTemplateDetails.data;
      });
      this.isViewTemplateLoading = false;
    } catch (error) {
      this.isViewTemplateLoading = false;
    }
  };
  loadActivityForInwards = async (id: string) => {
    this.loading = true;
    try {
      const activity = await agent.Activities.details(id);
      this.setActivity(activity.data);
      runInAction(() => {
        this.selectedActivity = activity.data;
      });
      this.setLoadingInitial(false);
      return activity;
    } catch (error) {
      console.log(error);
      this.setLoadingInitial(false);
    }
  };

  showClickedValueForHFCShipper = async (shippingId: string) => {
    this.loading = true;
    try {
      const res = await agent.HFC.HFCShipperSelected(shippingId);
      if (res.data) {
        let associatedAssets =
          res.data.assets_Associated_with_Title_and_Asset_ID;

        try {
          const assetsRes = await agent.HFC.HFClistAssetWAssetId(
            res.data.assetName as string,
          );
          associatedAssets = assetsRes.data
            .map((obj: Record<string, string>) => {
              return Object.values(obj).join(', ') + ', ';
            })
            .join('\n');
        } catch (assetError) {
          console.error('Error fetching associated HFC assets:', assetError);
        }

        this.selectedShipper = {
          ...res.data,
          assets_Associated_with_Title_and_Asset_ID: associatedAssets,
        };
      } else {
        console.error("No data received from API");
      }
    } catch (error) {
      console.error("Error fetching HFC Shipper:", error);
    } finally {
      this.loading = false;
    }
  };

  showClickedValueForHFCReceiving = async (shippingId: string) => {
    this.loading = true;
    try {
      const res = await agent.HFC.HFCShipperSelected(shippingId);
      if (res.data) {
          this.selectedReceiver = res.data;
      } else {
        console.error("No data received from API");
      }
    } catch (error) {
      console.error("Error fetching HFC Shipper:", error);
    } finally {
      this.loading = false;
    }
  };

  showClickedValueForHFCServiceAssign = async (shippingId: string) => {
    this.loading = true;
    try {
      const res = await agent.HFC.HFCServiceAssign(shippingId);
      if (res.data) {
            this.selectedService = res.data;
      } else {
        console.error("No data received from API");
      }
    } catch (error) {
      console.error("Error fetching HFC Shipper:", error);
    } finally {
      this.loading = false;
    }
  };

  showClickedValueForHFCServiceReturn = async (shippingId: string) => {
    this.loading = true;
    try {
      const res = await agent.HFC.HFCServiceAssign(shippingId);
      if (res.data) {
            this.selectedReturn = res.data;
      } else {
        console.error("No data received from API");
      }
    } catch (error) {
      console.error("Error fetching HFC Shipper:", error);
    } finally {
      this.loading = false;
    }
  };

  showClickedValueForHFCCustomerrequest = async (shippingId: string) => {
    this.loading = true;
    try {
      const res = await agent.HFC.HFCCustomerrequest(shippingId);
      if (res.data) {
          this.selectedServiceAssign = res.data;
      } else {
        console.error("No data received from API");
      }
    } catch (error) {
      console.error("Error fetching HFC Shipper:", error);
    } finally {
      this.loading = false;
    }
  };
  

  private getActivity = (id: string) => {
    return this.activityRegistry.get(id);
  };

  setLoadingInitial = (state: boolean) => {
    this.loadingInitial = state;
  };

  updateActivity = async (activity: ActivityFormValues) => {
    this.loading = true;
    try {
      await agent.Activities.update(activity);
      runInAction(() => {
        if (activity.id) {
          const updatedActivity = {
            ...this.getActivity(activity.id),
            ...activity,
          };
          this.activityRegistry.set(activity.id, updatedActivity as Activity);
          this.selectedActivity = updatedActivity as Activity;
        }
      });
      toast.success('Activity updated succesfully.');
    } catch (error) {
      console.log(error);
    }
  };

  updateAttendance = async (userId: any, assignUser: any) => {
    try {
      await agent.Activities.attend(this.selectedActivity!.id, userId);
      runInAction(() => {
        if (this.selectedActivity) {
          this.selectedActivity?.assignedUsers?.push(assignUser);
        }
        this.activityRegistry.set(this.selectedActivity!.id, userId);
        store.mediaAssetStore.mediaAsset.assignuserId = userId;
        toast.success('User Added Succesfully');
        // toast.info('Email Sent Succesfully');
      });
    } catch (error) {
      this.errorMessageKalaingarr = true;
      this.eroorr = false;
      console.log(error);
    }
  };

  clearWorkflowStore = () => {
    store.viewStore.resetActiveOrder();
  };

  clearSelectedActivity = () => {
    this.selectedActivity = undefined;
  };
  // Inward
  createInward = async (activity: Activity) => {
    this.loading = true;
    try {
      await agent.Inwards.create(activity);

      runInAction(() => {
        this.activityRegistry.set(activity.id, activity);
        this.inwardsRegistry.set(activity.id, activity);
        this.updateActivity(activity);
        //this.editMode = false;
        this.loading = false;
      });
      toast.success(' Asset Updated Successfully ');
      //  toast.info('Email Sent Successfully')
    } catch (error) {
      console.log(error);
      runInAction(() => {
        this.loading = false;
      });
    }
  };
  //  Create Delivery
  createDelivery = async (activity: Activity) => {
    this.loading = true;
    try {
      await agent.Deliveries.create(activity);
      await agent.Activities.update(activity);
      store.DeliveryStore.loadAllDelivery();
      runInAction(() => {
        this.activityRegistry.set(activity.id, activity);
        this.loading = false;
      });
      toast.success('Asset Updated Successfully ');
      store.DeliveryStore.loadAllDelivery(); // reload data to check the delivery
      store.WorkLevelStore.loadWorkLevels(); // reload data to check the worklevel
      this.loadActivities();
      //  toast.info('Email Sent Successfully')
    } catch (error) {
      console.log(error);
      runInAction(() => {
        this.loading = false;
      });
    }
  };

  ////////////////////////////////////// update item level in worklevel
  loadActivitiesTag = async (id: string) => {
    this.setLoadingInitial(true);

    try {
      this.activityRegistryAll = new Map<string, Activity>();

      const activities = await agent.Activities.list();
      runInAction(() => {
        activities.forEach((activity) => {
          this.setActivityAll(activity);
          this.isActivity = true;
        });
      });

      this.setLoadingInitial(false);
      this.loadActivity(id);
      store.dashboardStore.updateRowData(id);
    } catch (error) {
      console.log(error);
      this.setLoadingInitial(false);
    }
  };
  updateItemLevel = async (WorkLevel: WorkLevelItem, DynItemCheck?: string) => {
    // let ids = store.userStore.user?.id
    this.loading = true;
    try {
      await agent.WorkLevels.updateItemLevel(WorkLevel);
      runInAction(() => {
        WorkLevel.items.forEach(async (activity) => {
          const payload: historyPayloadType = {
            taskId: '',
            taskName: '',
            subTaskId: '',
            subTaskName: '',
            status: `${activity.title} is ${
              DynItemCheck ? `Item Created ` : `verified `
            } successfully by ${store.userStore.user?.displayName!}`,
            date: new Date(),
          };
          // updateHistoryMain(payload, false, true);
          await store.viewStore.addHistory(
            { itemId: activity.id },
            payload,
            false,
            true,
          );
          this.setActivityAll(activity);
        });

        //    this.loadActivitiesTag(WorkLevel.items[0].id);

        this.selectedActivity = WorkLevel.items[0];
        this.setLoadingInitial(false);
        //    this.loadActivity(WorkLevel.items[0].id);
        store.dashboardStore.updateRowData(WorkLevel.items[0].id);
      });
      // this.selectedActivity=WorkLevel.items[0];

      this.isActivity = false; //updating order count
    } catch (error) {
      console.log(error);
      runInAction(() => {
        this.loading = false;
      });
    }
  };
  updateItemLevelSections = async (
    WorkLevel: WorkLevelItem,
    id: string,
    HistoryArr2: any,
  ) => {
    // let ids = store.userStore.user?.id
    this.loading = true;
    try {
      await agent.WorkLevels.updateItemLevel(WorkLevel);
      runInAction(() => {
        WorkLevel.items.forEach((activity) => {
          store.clonedStore.loadSectionMultipleById(id);
          store.clonedStore.loadSectionById(id);
          this.selectedActivity?.itemHistory?.unshift(HistoryArr2);
        });
      });
    } catch (error) {
      console.log(error);
      runInAction(() => {
        this.loading = false;
      });
    }
  };
  downloadFilesStore = async (data: string, fileName: string) => {
    try {
      const downloadVal = await agent.Activities.downloadFiles(data);
      runInAction(() => {
        this.downloadFileStarted = downloadVal;
        fileDownload(downloadVal.data, fileName);
      });
    } catch (error) {
      console.log(error);
    }
  };
  //////////////////////////////////for inwards
  loadInwards = async () => {
    this.loadingInitial = true;
    if (store.userStore.user?.id !== undefined) {
      try {
        const inwards = await agent.Activities.listInwards();
        const user = store.userStore.user;
        inwards.forEach((inwards) => {
          if (user) {
            runInAction(() => {
              this.setInwards(inwards);
            });
          }
        });
        this.setLoadingInitial(false);
      } catch (error) {
        console.log(error);
        this.setLoadingInitial(false);
      }
    }
  };

  private setInwards = (activity: Activity) => {
    const user = store.userStore.user;
    if (user) {
      activity.isHost = activity.hostUsername === user.username;
      activity.host = activity.assignedUsers?.find(
        (x) => x.username === activity.hostUsername,
      );
    }

    this.inwardsRegistry.set(activity.id, activity);
  };

  updateActivityProcessDelivery = async (deliveryRequest: DeliveryRequest) => {
    this.loading = true;

    try {
      await agent.Deliveries.update(deliveryRequest);

      this.loading = false;
      toast.success('Asset Updated Successfully.');
      // toast.info('Email Sent Succesfully.');
    } catch (error) {
      console.log(error);
      runInAction(() => {
        this.loading = false;
      });
    }
  };
  /////////////////////for outwards
  loadOutwards = async () => {
    this.loadingInitial = true;
    if (store.userStore.user?.id !== undefined) {
      try {
        const outwards = await agent.Activities.listOutwards();
        const user = store.userStore.user;
        outwards.forEach((outwards) => {
          if (user) {
            runInAction(() => {
              this.setOutwards(outwards);
            });
          }
        });
        this.setLoadingInitial(false);
      } catch (error) {
        console.log(error);
        this.setLoadingInitial(false);
      }
    }
  };
  private setOutwards = (activity: Activity) => {
    const user = store.userStore.user;
    if (user) {
      activity.isHost = activity.hostUsername === user.username;
      activity.host = activity.assignedUsers?.find(
        (x) => x.username === activity.hostUsername,
      );
    }

    this.outwardsRegistry.set(activity.id, activity);
  };
  ///////////////////////////////load Delivery
  loadDeliveries = async () => {
    this.loadingInitial = true;

    if (store.userStore.user?.id !== undefined) {
      try {
        const deliveries = await agent.Activities.listDeliveries();

        runInAction(() => {
          deliveries.forEach((deliveries) => {
            this.setDeliveries(deliveries);
          });
        });
        this.setLoadingInitial(false);
      } catch (error) {
        console.log(error);
        this.setLoadingInitial(false);
      }
    }
  };

  private setDeliveries = (activity: Activity) => {
    const user = store.userStore.user;
    if (user) {
      activity.isHost = activity.hostUsername === user.username;
      activity.host = activity.assignedUsers?.find(
        (x) => x.username === activity.hostUsername,
      );
    }

    this.deliveryRegistry.set(activity.id, activity);
  };

  loadActivityForDelivery = async (id: string) => {
    this.orderRegisterTrigger = true;
    try {
      const activity = await agent.Activities.detailsForOrders(id);

      this.setDeliveries(activity);
      runInAction(() => {
        this.selectedDelivery = activity;
      });
      this.orderRegisterTrigger = false;
      return activity;
    } catch (error) {
      console.log(error);
      this.orderRegisterTrigger = false;
    }
  };

  //date and time
  updateDateTime = () => {
    const today: any = new Date();
    let dd = today.getDate();
    let mm = today.getMonth() + 1;

    const yyyy = today.getFullYear();
    if (dd < 10) {
      dd = '0' + dd;
    }
    if (mm < 10) {
      mm = '0' + mm;
    }
    const time = new Date().toLocaleTimeString();
    return dd + '/' + mm + '/' + yyyy + ' ' + time;
  };

  collectMetaData = async (id: any) => {
    try {
      const metaData = await agent.mediaAsset.getMetaData(id);
      runInAction(() => {
        this.metaDataVal = metaData;
      });
      return metaData;
    } catch (error) {
      console.log(error);
    }
  };

  collectMetaDataHFC = async (id: any) => {
    try {
      const metaData = await agent.mediaAsset.getHFCMetaData(id);
      runInAction(() => {
        this.metaDataVal = metaData;
      });
      return metaData;
    } catch (error) {
      console.log(error);
    }
  };

  updateMetaData = async (data: any, history: any, hisStoreData: any) => {
    try {
      await agent.mediaAsset.putMetaData(data);
      runInAction(() => {
        this.metaDataVal = data;
        toast.info('Manage Assets saved successfully');
      });
      store.viewStore.viewPageHistoryAlone({
        itemId: this.selectedActivity!.id,
        pageNo: 1,
        pageSize: 4,
      });
    } catch (error) {
      console.log(error);
    }
  };

  uploadAssetCover = async (id: string, thumbnail: string, preview: string) => {
    try {
      const payload = {
        id,
        thumbnail,
        preview,
      };
      await agent.mediaAsset.uploadAssetCover(payload);
      toast.success('Upload successful');
    } catch {
      toast.error('Upload failed. Please try again.');
    }
  };

  trackGate = async (id: string, gate: string, direction: string) => {
    try {
      const trackgate = await agent.Activities.trackGate(id, gate, direction);
      runInAction(() => {
        this.trackgatemessage = trackgate.data;
      });
    } catch (error) {
      console.log(error);
    }
  };
  updateActivityMetaData = async (id: string) => {
    try {
      await agent.Activities.updateAssetMetaData(id);

      runInAction(() => {
        this.collectMetaData(id);
      });
    } catch (error) {
      toast.success('Failed to updated metadata');
    }
  };

  updatemetadataHeadersPostItemID = async (id: string) => {
    try {
      await agent.Reports.metadataHeadersPostItemID(id);
    } catch (error) {
      console.log(error);
    }
  };

  getItemPropertyDetailsAPI = async (id: string) => {
    try {
      const itemProperties = await agent.mediaAsset.getItemPropertyDetails(id);
      const metaDataDetails = await agent.mediaAsset.getItemMetadataDetails(id);
      if (itemProperties) {
        itemProperties.metadata = metaDataDetails;
      }
      this.metaDataVal = itemProperties;

      // this.selectedActivity=metaData;
      runInAction(() => {});
    } catch (error) {
      console.log(error);
    }
  };

  createManageDetailsAPI = async (data: any, id: string) => {
    try {
      const itemGroupDetails = await agent.WorkLevels.createDetailsItem(id);
      itemGroupDetails.year = `${new Date().getFullYear()}`;
      itemGroupDetails.originIndia = 'India';
      itemGroupDetails.language = 'English';
      delete data.assignedUsers;
      data.isReceiving = false;
      data.isDelivery = false;
      itemGroupDetails.items = [data];
      await agent.WorkLevels.updateItemLevel(itemGroupDetails);
      return itemGroupDetails;
    } catch (error) {
      console.log(error);
    }
  };

  // inventory reports

  inventoryReportsCaseHandler = (
    isLoading: boolean,
    tableResult: any,
    countResult: any,
    pageNum: number,
    name: string,
  ) => {
    let payload = {
      isLoading,
      pageNumber: pageNum,
      count: countResult,
      data: tableResult,
    };
    switch (name) {
      case 'NewAssetAdded':
        this.inventoryReports.newAssetAdded = {
          ...this.inventoryReports.newAssetAdded,
          ...payload,
        };
        break;
      case 'CurrentMonthAssetCANMovement':
        this.inventoryReports.currentMonthAssetCANMovement = {
          ...this.inventoryReports.currentMonthAssetCANMovement,
          ...payload,
        };
        break;
      case 'PendingReturnsFromBorrowers':
        this.inventoryReports.pendingReturnsFromBorrowers = {
          ...this.inventoryReports.pendingReturnsFromBorrowers,
          ...payload,
        };
        break;
      case 'AssetsCleaned':
        this.inventoryReports.assetsCleaned = {
          ...this.inventoryReports.assetsCleaned,
          ...payload,
        };
        break;
      case 'AssetsScheduledForCleaning':
        this.inventoryReports.assetsScheduledForCleaning = {
          ...this.inventoryReports.assetsScheduledForCleaning,
          ...payload,
        };
        break;
      case 'DigitalizationPriority':
        this.inventoryReports.digitalizationPriority = {
          ...this.inventoryReports.digitalizationPriority,
          ...payload,
        };
        break;
    }
  };
  inventoryReportsFetchTableDetails = async (
    searchValue: string,
    pageNum: number,
    name: string,
  ) => {
    try {
      this.inventoryReportsCaseHandler(true, [], 0, 1, name);
      let params = {
        item: searchValue || '',
        PageNumber: pageNum,
        PageSize: 5,
      };
      let [tableResult, countResult] = await Promise.all([
        agent.Activities.searchInventoryReportsTableDetails(params, name),
        agent.Activities.countInventoryReportsTableDetails(
          { item: searchValue || '' },
          name,
        ),
      ]);
      this.inventoryReportsCaseHandler(
        false,
        tableResult?.data || [],
        countResult?.data || [],
        pageNum,
        name,
      );
    } catch (error) {
      this.inventoryReportsCaseHandler(true, [], 0, pageNum, name);
      console.log(error);
    }
  };
  inventoryReportsFetchSortTableDetails = async (
    orderBy: string,
    name: string,
    searchValue: string,
    pageNum: number,
    count: number,
  ) => {
    try {
      this.inventoryReportsCaseHandler(true, [], count, pageNum, name);
      let params = {
        orderBy,
        name: searchValue,
        PageNumber: pageNum || 1,
        PageSize: 5,
      };
      let tableResult = await agent.Activities.sortInventoryReportsTableDetails(
        params,
        name,
      );
      this.inventoryReportsCaseHandler(
        false,
        tableResult?.data || [],
        count,
        pageNum,
        name,
      );
    } catch (error) {
      this.inventoryReportsCaseHandler(true, [], count, pageNum, name);
      console.log(error);
    }
  };

  // order reports

  OrdersReportsCaseHandler = (
    isLoading: boolean,
    tableResult: any,
    countResult: any,
    pageNum: number,
    name: string,
  ) => {
    let payload = {
      isLoading,
      pageNumber: pageNum,
      count: countResult,
      data: tableResult,
    };
    switch (name) {
      case 'Approved':
        this.OrdersReports.approved = {
          ...this.OrdersReports.approved,
          ...payload,
        };
        break;
      case 'Delivered':
        this.OrdersReports.delivered = {
          ...this.OrdersReports.delivered,
          ...payload,
        };
        break;
      case 'InProgress':
        this.OrdersReports.inProgress = {
          ...this.OrdersReports.inProgress,
          ...payload,
        };
        break;
      case 'Ready':
        this.OrdersReports.ready = {
          ...this.OrdersReports.ready,
          ...payload,
        };
        break;
      case 'Received':
        this.OrdersReports.received = {
          ...this.OrdersReports.received,
          ...payload,
        };
        break;
      case 'Returned':
        this.OrdersReports.returned = {
          ...this.OrdersReports.returned,
          ...payload,
        };
        break;
      case 'WaitingforApproval':
        this.OrdersReports.waitingforApproval = {
          ...this.OrdersReports.waitingforApproval,
          ...payload,
        };
        break;
    }
  };
  OrdersReportsFetchTableDetails = async (
    searchValue: string,
    pageNum: number,
    name: string,
  ) => {
    try {
      this.OrdersReportsCaseHandler(true, [], 0, 1, name);
      let params = {
        item: searchValue,
        PageNumber: pageNum,
        PageSize: 5,
      };
      let [tableResult, countResult] = await Promise.all([
        agent.Activities.searchOrderReportsTableDetails(params, name),
        agent.Activities.countOrderReportsTableDetails(
          { item: searchValue },
          name,
        ),
      ]);
      this.OrdersReportsCaseHandler(
        false,
        tableResult?.data || [],
        countResult?.data || [],
        pageNum,
        name,
      );
    } catch (error) {
      this.OrdersReportsCaseHandler(true, [], 0, 1, name);
      console.log(error);
    }
  };
  OrdersReportsFetchSortTableDetails = async (
    orderBy: string,
    name: string,
    searchValue: string,
    pageNum: number,
    count: number,
  ) => {
    try {
      this.OrdersReportsCaseHandler(true, [], count, pageNum, name);
      let params = {
        orderBy,
        name: searchValue,
        PageNumber: pageNum || 1,
        PageSize: 5,
      };
      let tableResult = await agent.Activities.sortOrderReportsTableDetails(
        params,
        name,
      );
      this.OrdersReportsCaseHandler(
        false,
        tableResult?.data || [],
        count,
        pageNum,
        name,
      );
    } catch (error) {
      this.OrdersReportsCaseHandler(true, [], count, pageNum, name);
      console.log(error);
    }
  };

  inwardCaseHandler = (
    isLoading: boolean,
    tableResult: any,
    countResult: any,
    pageNum: number,
    name: string,
  ) => {
    let payload = {
      isLoading,
      pageNumber: pageNum,
      count: countResult,
      data: tableResult,
    };
    switch (name) {
      case 'Verify':
        this.inward.verify = {
          ...this.inward.verify,
          ...payload,
        };
        break;
      case 'Approve':
        this.inward.approve = {
          ...this.inward.approve,
          ...payload,
        };
        break;
      case 'MoveToVault':
        this.inward.moveToVault = {
          ...this.inward.moveToVault,
          ...payload,
        };
        break;
      case 'PickerAssign':
        this.inward.PickerAssign = {
          ...this.inward.PickerAssign,
          ...payload,
        };
        break;
    }
  };

  inwardFetchTableDetails = async (
    searchValue: string,
    pageNum: number,
    name: string,
  ) => {
    try {
      this.inwardCaseHandler(true, [], 0, 1, name);
      let params = {
        item: searchValue,
        PageNumber: pageNum,
        PageSize: 5,
      };
      let [tableResult, countResult] = await Promise.all([
        agent.Inwards.searchInwardTableDetails(params, name),
        agent.Inwards.countInwardTableDetails({ item: searchValue }, name),
      ]);
      this.inwardCaseHandler(
        false,
        tableResult?.data || [],
        countResult?.data || [],
        pageNum,
        name,
      );
    } catch (error) {
      this.inwardCaseHandler(true, [], 0, 1, name);
      console.log(error);
    }
  };

  inwardFetchSortTableDetails = async (
    orderBy: string,
    name: string,
    searchValue: string,
    pageNum: number,
    count: number,
  ) => {
    try {
      this.inwardCaseHandler(true, [], count, pageNum, name);
      let params = {
        orderBy,
        name: searchValue,
        PageNumber: pageNum || 1,
        PageSize: 5,
      };
      let tableResult = await agent.Inwards.sortInwardTableDetails(
        params,
        name,
      );
      this.inwardCaseHandler(
        false,
        tableResult?.data || [],
        count,
        pageNum,
        name,
      );
    } catch (error) {
      this.inwardCaseHandler(true, [], 0, 1, name);
      console.log(error);
    }
  };

  outwardCaseHandler = (
    isLoading: boolean,
    tableResult: any,
    countResult: any,
    pageNum: number,
    name: string,
  ) => {
    let payload = {
      isLoading,
      pageNumber: pageNum,
      count: countResult,
      data: tableResult,
    };
    switch (name) {
      case 'TagOrder':
        this.outward.tagOrder = {
          ...this.outward.tagOrder,
          ...payload,
        };
        break;
      case 'Unvault':
        this.outward.unvault = {
          ...this.outward.unvault,
          ...payload,
        };
        break;
      case 'VerifyOutward':
        this.outward.verifyOutward = {
          ...this.outward.verifyOutward,
          ...payload,
        };
        break;
      case 'ApproveOutward':
        this.outward.approveOutward = {
          ...this.outward.approveOutward,
          ...payload,
        };
        break;
      case 'AssignPickerOutward':
        this.outward.assignPickerOutward = {
          ...this.outward.assignPickerOutward,
          ...payload,
        };
        break;
      case 'Move':
        this.outward.move = {
          ...this.outward.move,
          ...payload,
        };
        break;
      case 'Package':
        this.outward.package = {
          ...this.outward.package,
          ...payload,
        };
        break;
      case 'Billing':
        this.outward.billing = {
          ...this.outward.billing,
          ...payload,
        };
        break;
    }
  };

  outwardFetchTableDetails = async (
    searchValue: any,
    pageNum: number,
    name: string,
  ) => {
    try {
      this.outwardCaseHandler(true, [], 0, 1, name);
      let params = {
        item: searchValue !== '' ? JSON.stringify(searchValue) : searchValue,
        PageNumber: pageNum,
        PageSize: 5,
      };
      let [tableResult, countResult] = await Promise.all([
        agent.Outwards.searchOutwardTableDetails(params, name),
        agent.Outwards.countOutwardTableDetails(
          {
            item:
              searchValue !== '' ? JSON.stringify(searchValue) : searchValue,
          },
          name,
        ),
      ]);
      this.outwardCaseHandler(
        false,
        tableResult?.data || [],
        countResult?.data || [],
        pageNum,
        name,
      );
    } catch (error) {
      this.outwardCaseHandler(true, [], 0, 1, name);
      console.log(error);
    }
  };

  outwardFetchSortTableDetails = async (
    orderBy: string,
    name: string,
    searchValue: string,
    pageNum: number,
    count: number,
  ) => {
    try {
      this.outwardCaseHandler(true, [], count, pageNum, name);
      let params = {
        orderBy,
        name: searchValue,
        PageNumber: pageNum || 1,
        PageSize: 5,
      };
      let tableResult = await agent.Outwards.sortOutwardTableDetails(
        params,
        name,
      );
      this.outwardCaseHandler(
        false,
        tableResult?.data || [],
        count,
        pageNum,
        name,
      );
    } catch (error) {
      this.outwardCaseHandler(true, [], 0, 1, name);
      console.log(error);
    }
  };

  tagOrderFetchTableDetails = async (
    searchValue: string,
    pageNum: number,
    name: string,
  ) => {
    try {
      this.outwardCaseHandler(true, [], 0, 1, name);
      let params = {
        item: searchValue,
        PageNumber: pageNum,
        PageSize: 5,
      };
      let [tableResult, countResult] = await Promise.all([
        agent.Activities.searchTagOrderDetails(params),
        agent.Activities.countTagOrderDetails({ item: searchValue }),
      ]);
      this.outwardCaseHandler(
        false,
        tableResult?.data || [],
        countResult?.data || [],
        pageNum,
        name,
      );
    } catch (error) {
      this.outwardCaseHandler(true, [], 0, 1, name);
      console.log(error);
    }
  };

  tagOrderFetchSortTableDetails = async (
    orderBy: string,
    name: string,
    searchValue: string,
    pageNum: number,
    count: number,
  ) => {
    try {
      this.outwardCaseHandler(true, [], count, pageNum, name);
      let params = {
        orderBy,
        name: searchValue,
        PageNumber: pageNum || 1,
        PageSize: 5,
      };
      let tableResult = await agent.Activities.sortTagOrderDetails(params);
      this.outwardCaseHandler(
        false,
        tableResult?.data || [],
        count,
        pageNum,
        name,
      );
    } catch (error) {
      this.outwardCaseHandler(true, [], 0, 1, name);
      console.log(error);
    }
  };

  setopenviewmodel = (e: boolean) => {
    this.setOpenmovementview = e;
  };

  OrderModelTab = async (id: string, pagenumber: number) => {
    try {
      if (typeof pagenumber === 'number') {
        this.orderTabload = true;
        const modelData: any = await agent.CreateOrder.OrderPagination(
          id,
          pagenumber,
        );
        runInAction(() => {
          this.AssetsOrderInfomation = modelData.data;
          this.orderTabload = false;
        });
      }
    } catch (error) {
      console.log('OrderModelTab failed');
      this.orderTabload = false;
    }
  };

  OrderTabCount = async (data: string) => {
    const count = await agent.CreateOrder.orderCount(data);
    if (count !== undefined && count.data !== undefined) {
      this.orderHistoryCount = count.data;
    }
  };
  QuickscanCheckboxisChekcer = (item: boolean) => {
    this.ActivityQuickscanIs = item;
  };
  videoIntelligenceAssetIdInfo = async (item: any) => {
    try {
      this.isFilterApiCalled = true;
      let activitiesArray: any[] = [];
      // let hasData = !!(this.Filter || this.FilterById || this.FilterCategory);
      const p1 = new Promise(async (resolve) => {
        item.forEach(async (item1: any) => {
          let activities: Activity[] = [];
          activities =
            await agent.Activities.searchAndItemGroupsAndFilterAssetsAPI(
              item1,
              '',
              '',
              1,
              10,
            );
          activitiesArray.push(...activities);
        });
        resolve('');
      });
      p1.then(() => {
        setTimeout(async () => {
          this.isFilterApiCalled = true;
          if (!this.isThisFilterCategory) {
            let filterAssetsDetails = await agent.Activities.getFilterCountsAPI(
              this.Filter,
              this.FilterById,
              '',
            );
            if (this.FilterCategory === '') {
              let countValue = 0;
              Object.values(filterAssetsDetails).forEach((value: any) => {
                countValue += value;
              });

              this.filteredAssetsCount = countValue;
            }
            this.filterAssetsDetails = filterAssetsDetails;
          }
          this.isThisFilterCategory = false;
          this.activitiesStore(activitiesArray);
          this.isFilterApiCalled = false;
        }, 1000);
      });
    } catch (error) {
      console.log(error);
    }
  };
  videoIntelligenceCount = (data: number) => {
    this.filteredAssetsCount = data;
  };

  inventorySearchList = async (headerName: string) => {
    try {
      const response = await agent.Activities.inventorySearchList(headerName);
      return response?.data;
    } catch {
      toast.error('Something went wrong ! Please try again.');
    }
  };

  Fedex = async (payload: any) => {
    try {
      const res = await agent.HFC.Fedex(payload);
      runInAction(() => {
        // Check if an image with the same id already exists in the array
        const existingImageIndex = this.imageSrc.findIndex(image => image.packageNumber === res.data.packageNumber);
        
        if (existingImageIndex !== -1) {
          // If the image exists, replace its imageUrl
          this.imageSrc[existingImageIndex].imageUrl = res.data.imageUrl;
        } else {
          // If the image doesn't exist, add it to the array
          this.imageSrc.push({
            packageNumber: res.data.packageNumber,
            imageUrl: res.data.imageUrl
          });
        }
      });
    } catch (error) {
      console.log(error);
    }
  };
}
